<main class="terms-of-use-component">
  <div class="wrapper scroll" id="mainAppScroll">
    <div class="content">
      <span
        class="fixed-space-32"
        aria-hidden="true"
        *ngIf="(lessThan$ | async)?.mobileL !== true"></span>
      <article class="content-wrapper">
        <section *ngIf="lang !== 'AR'">
          <h1 class="c22" id="h.exij5bfsu05u"><span class="c2">TERMS OF USE</span></h1>
          <p class="c24"><span class="c4">Last updated February 23 , 2023</span></p>
          <ul class="c9 lst-kix_fpg2lo2mx7gq-0 start">
            <li class="c1 li-bullet-0">
              <span class="c5 c10"
                >This website shall be subject to United Arab Emirates law for any
                disputes or claims arising out of or related to it.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c10 c5"
                >Users under the age of 18 are prohibited from registering as Users of
                this website and cannot transact or use the website.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c10 c5"
                >We use a secured connection to connect directly to our payment provider
                if you make a payment for our products or services on our website.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c10 c5"
                >The cardholder must retain a copy of transaction records and Merchant
                policies and rules.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c10 c5"
                >We accept payments online using Visa and MasterCard credit/debit card in
                local currency, or via any of our installment providers</span
              >
            </li>
          </ul>
          <h2 class="c0" id="h.uv0qtrk15fq7">
            <span class="c6 c2">AGREEMENT TO TERMS</span>
          </h2>
          <p class="c7">
            <span
              >These Terms of Use constitute a legally binding agreement made between you,
              whether personally or on behalf of an entity (“you”) and Popsy LLC
              (“Company”, “we”, “us”, or “our”), concerning your access to and use of the </span
            ><span
              ><a
                class="c18"
                href="https://www.google.com/url?q=https://www.popsy.app/&amp;sa=D&amp;source=editors&amp;ust=1680258966925073&amp;usg=AOvVaw2ltM0L4M05kqjdo-EfT5cy"
                >https://www.popsy.app</a
              ></span
            ><span class="c4"
              >&nbsp;website as well as any other media form, media channel, mobile
              website or mobile application related, linked, or otherwise connected
              thereto (collectively, the “Site”). The Site provides an online E-commerce
              store for general goods, products, and/or services (the “E-commerce
              Offerings”). In order to help make the Site a secure environment for the
              purchase and sale of E-commerce Offerings, all users are required to accept
              and comply with these Terms of Use. You agree that by accessing the Site
              and/or the E-commerce Offerings, you have read, understood, and agree to be
              bound by all of these Terms of Use. IF YOU DO NOT AGREE WITH ALL OF THESE
              TERMS OF USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND/OR
              THE E-commerce OFFERINGS AND YOU MUST DISCONTINUE USE IMMEDIATELY.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >Supplemental terms and conditions or documents that may be posted on the
              Site from time to time are hereby expressly incorporated herein by
              reference. We reserve the right, in our sole discretion, to make changes or
              modifications to these Terms of Use at any time and for any reason. We will
              alert you about any changes by updating the “Last updated” date of these
              Terms of Use, and you waive any right to receive specific notice of each
              such change. It is your responsibility to periodically review these Terms of
              Use to stay informed of updates. You will be subject to, and will be deemed
              to have been made aware of and to have accepted, the changes in any revised
              Terms of Use by your continued use of the Site after the date such revised
              Terms of Use are posted.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >The information provided on the Site is not intended for distribution to or
              use by any person or entity in any jurisdiction or country where such
              distribution or use would be contrary to law or regulation or which would
              subject us to any registration requirement within such jurisdiction or
              country. Accordingly, those persons who choose to access the Site from other
              locations do so on their own initiative and are solely responsible for
              compliance with local laws, if and to the extent local laws are
              applicable.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >The Site is intended for users who are at least 13 years of age. All users
              who are minors in the jurisdiction in which they reside (generally under the
              age of 18) must have the permission of, and be directly supervised by, their
              parent or guardian to use the Site. If you are a minor, you must have your
              parent or guardian read and agree to these Terms of Use prior to you using
              the Site.</span
            >
          </p>
          <h2 class="c0 c14" id="h.wirxivdxdufc"><span>CANCELLATION POLICY</span></h2>
          <p class="c7">
            <span class="c10 c5"
              >When a cancellation request is made, the order status will be reviewed. If
              the order has already been dispatched, the customer must pay the shipping
              fees in order to cancel it.</span
            >
          </p>
          <p class="c7">
            <span>
              Please note that purchases made using Quara cannot be canceled once the
              transaction is processed. Refunds are not applicable for transactions
              completed through Quara. All sales are final.</span
            >
          </p>
          <h2 class="c0 c14" id="h.xpoffqm638u3">
            <span class="c6 c2">SHIPMENT AND DELIVERY POLICY</span>
          </h2>
          <p class="c7">
            <span class="c10 c5"
              >Shipment is free of charge.Items are shipped between 2-3 days depending on
              supplier’s available stock. Delivery estimates are within approximately 5-7
              days.</span
            >
            <span class="c10 c5">
              Customers who refuse to accept delivery of their orders will be charged 100%
              of the order value, as the product has already been dispatched. If a
              customer wishes to cancel an order after it has been shipped, they are
              required to accept the delivery and then initiate a return request through
              our designated process to be eligible for a full refund. This policy ensures
              efficient handling of orders and minimizes operational disruptions.
            </span>
          </p>
          <h2 class="c0 c14" id="h.dm5372crbzjw">
            <span>REFUND AND EXCHANGE POLICY</span>
          </h2>
          <p class="c16">
            <span class="c10 c5"
              >You can request a return/exchange/refund within 14-days after you receive
              the product and:</span
            >
          </p>
          <p class="c3">
            <span class="c12 c11">1.</span
            ><span class="c17 c11">&nbsp;If you received an incorrect product</span
            ><span class="c10 c5"
              >&nbsp;(as long as the product has not been used and it included all tags
              and original undamaged packaging). or</span
            >
          </p>
          <p class="c3">
            <span class="c12 c11">2. If you received a</span
            ><span class="c11 c17"
              >&nbsp;damaged product or if it isn't working properly</span
            ><span class="c12 c11"
              >. You will need to provide pictures and videos with the issue. Product
              should include all tags and undamaged original packaging. Returning a
              damaged device must be reported within three</span
            ><span class="c17 c11">&nbsp;business days of delivery.</span>
          </p>
          <p class="c3">
            <span class="c12 c11"
              >If you'd like to return a product that doesn't fit any of the reasons
              above,</span
            ><span class="c10 c2">&nbsp;returning fees may be applicable.</span>
          </p>

          <p class="c16">
            <span class="c10 c5">Returns are only accepted only if:</span>
          </p>
          <p class="c3">
            <span class="c10 c5"
              >1. You ship the product with its undamaged original package and tags;</span
            >
          </p>
          <p class="c3">
            <span class="c10 c5">2. All the accessories are included</span>
          </p>
          <p class="c3">
            <span class="c10 c5"
              >3. If the packaging has minor damages, or if the item doesn't show the
              issues previously reported a restocking fee of 25% (Percent) will be
              deducted while making exchange/refund.</span
            >
          </p>
          <p class="c3">
            <span class="c11 c12">4. You must send the product </span
            ><span class="c17 c11">without</span
            ><span class="c10 c5">&nbsp;login (Apple, Google etc).</span>
          </p>
          <p class="c3"><span class="c10 c5">Which products I can't return?</span></p>
          <p class="c3">
            <span class="c10 c5"
              >1. Products that have been used or damaged by you or are not in the same
              condition as you received them;</span
            >
          </p>
          <p class="c3">
            <span class="c10 c5"
              >2. Any consumable product which has been used or installed;</span
            >
          </p>
          <p class="c3">
            <span class="c12 c11"
              >3. Products with tampered or missing serial numbers</span
            >
          </p>
          <p class="c7">
            <span class="c10 c5"
              >Upon successful pickup, our warehouse will inspect the purchased product,
              determine if it is eligible for a refund, and then process the refund
              according to the method of payment. Popsy reserves the right to reject a
              return request of a product and sends it back to the customer in case the
              product returned does not meet any of the return criteria explained
              above.</span
            >
          </p>
          <p class="c7">
            <span class="c11"
              >Should the product return request be declined, Popsy will make two attempts
              to deliver the product back to the customer via its approved courier
              services. If both attempts of delivery are unsuccessful, Popsy will hold the
              product for three (3) business days at its delivery hub. Within three (3)
              business days following the last attempt, the customer can request another
              attempt with our customer support team. Popsy shall apply a charge of AED /
              SAR 100 as RETURN FEES to be incurred by the Customer. If the customer
              doesn’t claim back the product, it will be sent for liquidation and the
              customer won’t be able to request the return of the product again. Popsy
              will not be held liable or responsible towards the customer. Customers shall
              not have the right to any compensation.</span
            >
          </p>
          <h2 class="c0 c14" id="h.745n1hsl7wx2"><span>WARRANTY</span></h2>
          <p class="c7">
            <span class="c10 c5"
              >You will need to submit a warranty request to our customer service team,
              who will reach out to you and provide a free return label as soon as
              possible. You will be required to give details on your purchase and defect.
              As soon as we receive the returned product, it will be inspected and
              repaired/replaced. In case neither repair nor replacement is possible, we
              will arrange for a partial or full refund for the product in cash or store
              credit. We aim to settle all our claims within 10 working days.</span
            >
          </p>
          <p class="c7">
            <span class="c10 c5"
              >Please note that repaired devices or replacements can only be sent out
              after the inspection &amp; repair. You are responsible for packing the
              device securely for shipping. Any damage or loss while in transit is the
              sender's responsibility.
            </span>
          </p>
          <p class="c7">
            <span class="c10 c5">What is NOT covered on the Warranty Policy?</span>
          </p>
          <p class="c7">
            <span class="c10 c5"
              >- Any damage or malfunction arising out of or directly caused by liquid
              ingress</span
            >
          </p>
          <p class="c7">
            <span class="c10 c5"
              >- Gradual wear and tear and cosmetic damages that do not affect the device
              functionality</span
            >
          </p>
          <p class="c7">
            <span class="c10 c5"
              >- Any damages arising out of negligence or intentional malpractice</span
            >
          </p>
          <p class="c7">
            <span class="c10 c5"
              >- Any loss/deletion/corruption of any data stored on the device</span
            >
          </p>
          <p class="c7">
            <span class="c11"
              >Repairs may take up to 10 business days depending on the type of defect and
              level of repair, excluding return shipping time. In case the spare parts are
              not available, the repair timeline may be longer than 10 days.</span
            >
          </p>
          <h2 class="c0" id="h.79oujr5214jh">
            <span class="c6 c2">INTELLECTUAL PROPERTY RIGHTS</span>
          </h2>
          <p class="c7">
            <span class="c5">Unless otherwise indicated, the Site and the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings are our proprietary property and all source code,
              databases, functionality, software, website designs, audio, video, text,
              photographs, and graphics on the Site (collectively, the “Content”) and the
              trademarks, service marks, and logos contained therein (the “Marks”) are
              owned or controlled by us or licensed to us, and are protected by copyright
              and trademark laws and various other intellectual property rights and unfair
              competition laws of the United Arab Emirates, international copyright laws,
              and international conventions. The Content and the Marks are provided on the
              Site “AS IS” for your information and personal use only. Except as expressly
              provided in these Terms of Use, no part of the Site or the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings and no Content or Marks may be copied, reproduced,
              aggregated, republished, uploaded, posted, publicly displayed, encoded,
              translated, transmitted, distributed, sold, licensed, or otherwise exploited
              for any commercial purpose whatsoever, without our express prior written
              permission.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >Provided that you are eligible to use the Site, you are granted a limited
              license to access and use the Site and to download or print a copy of any
              portion of the Content to which you have properly gained access solely for
              your personal, non-commercial use. We reserve all rights not expressly
              granted to you in and to the Site, the Content and the Marks.</span
            >
          </p>
          <h2 class="c0" id="h.rsta112bh45j">
            <span class="c6 c2">USER REPRESENTATIONS</span>
          </h2>
          <p class="c7">
            <span class="c5">By using the Site or the </span><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings, you represent and warrant that:(1) all registration
              information you submit will be true, accurate, current, and complete; (2)
              you will maintain the accuracy of such information and promptly update such
              registration information as necessary; (3) you have the legal capacity and
              you agree to comply with these Terms of Use; (4) you are not under the age
              of 13; (5) you are not a minor in the jurisdiction in which you reside, or
              if a minor, you have received parental permission to use the Site; (6) you
              will not access the Site or the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings through automated or non-human means, whether through a
              bot, script or otherwise; (7) you will not use the Site for any illegal or
              unauthorized purpose; and (8) your use of the Site or the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings will not violate any applicable law or regulation.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >If you provide any information that is untrue, inaccurate, not current, or
              incomplete, we have the right to suspend or terminate your account and
              refuse any and all current or future use of the Site (or any portion
              thereof).</span
            >
          </p>
          <p class="c7">
            <span class="c5">You may not use the Site or the </span><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings for any illegal or unauthorized purpose nor may you, in the
              use of </span
            ><span>E-commerce</span
            ><span class="c5">&nbsp;Offerings, violate any laws. Among unauthorized </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings are the following: intoxicants of any sort; illegal drugs
              or other illegal products; alcoholic beverages; games of chance; and
              pornography or graphic adult content, images, or other adult products.
              Postings of any unauthorized products or content may result in immediate
              termination of your account and a lifetime ban from use of the Site.</span
            >
          </p>
          <p class="c7">
            <span class="c5"
              >We are a service provider and make no representations as to the safety,
              effectiveness, adequacy, accuracy, availability, prices, ratings, reviews,
              or legality of any of the information contained on the Site or the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings displayed or offered through the Site. You understand and
              agree that the content of the Site does not contain or constitute
              representations to be reasonably relied upon, and you agree to hold us
              harmless from any errors, omissions, or misrepresentations contained within
              the Site’s content. We do not endorse or recommend any </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings and the Site is provided for informational and advertising
              purposes only.</span
            >
          </p>
          <h2 class="c0" id="h.f14vvtastjey">
            <span class="c6 c2">USER REGISTRATION</span>
          </h2>
          <p class="c7">
            <span class="c5"
              >You may be required to register with the Site in order to access the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings. You agree to keep your password confidential and will be
              responsible for all use of your account and password. We reserve the right
              to remove, reclaim, or change a username you select if we determine, in our
              sole discretion, that such username is inappropriate, obscene, or otherwise
              objectionable.</span
            >
          </p>
          <h2 class="c0" id="h.xxfuvcn8a8pz">
            <span>E-commerce</span><span class="c6 c2">&nbsp;OFFERINGS</span>
          </h2>
          <p class="c7">
            <span class="c5"
              >We make every effort to display as accurately as possible the colors,
              features, specifications, and details of the </span
            ><span>E-commerce</span
            ><span class="c5">&nbsp;Offerings available on the Site. Certain </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings may be available exclusively online through the Site. Such </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings may have limited quantities and are subject to return or
              exchange only according to our Return Policy.</span
            >
          </p>
          <p class="c7">
            <span class="c5">We reserve the right to limit the quantities of the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings offered or available on the Site. All descriptions or
              pricing of the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings are subject to change at any time without notice, at our
              sole discretion. We reserve the right to discontinue any </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings at any time for any reason. We do not warrant that the
              quality of any of the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings purchased by you will meet your expectations or that any
              errors in the Site will be corrected.</span
            >
          </p>
          <h2 class="c0" id="h.fds1y8pkdv47">
            <span class="c6 c2">PURCHASES AND PAYMENT</span>
          </h2>
          <p class="c7">
            <span class="c4">We accept the following forms of payment:</span>
          </p>
          <ul class="c9 lst-kix_mtkpy3yjxa41-0 start">
            <li class="c15 li-bullet-0"><span class="c4">Visa</span></li>
            <li class="c15 li-bullet-0"><span class="c4">Mastercard</span></li>
            <li class="c15 li-bullet-0"><span class="c4">American Express</span></li>
            <li class="c15 li-bullet-0">
              <span class="c4">Payment in installments</span>
            </li>
          </ul>
          <p class="c7">
            <span class="c5"
              >You agree to provide current, complete, and accurate purchase and account
              information for all purchases of the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings made via the Site. You further agree to promptly update
              account and payment information, including email address, payment method,
              and payment card expiration date, so that we can complete your transactions
              and contact you as needed. Sales tax will be added to the price of purchases
              as deemed required by us. We may change prices at any time.
            </span>
          </p>
          <p class="c7">
            <span class="c4"
              >You agree to pay all charges at the prices then in effect for your
              purchases and any applicable shipping fees, and you authorize us to charge
              your chosen payment provider for any such amounts upon placing your order.
              We reserve the right to correct any errors or mistakes in pricing, even if
              we have already requested or received payment.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >We reserve the right to refuse any order placed through the Site. We may,
              in our sole discretion, limit or cancel quantities purchased per person, per
              household, or per order. These restrictions may include orders placed by or
              under the same customer account, the same payment method, and/or orders that
              use the same billing or shipping address. We reserve the right to limit or
              prohibit orders that, in our sole judgment, appear to be placed by dealers,
              resellers, or distributors.</span
            >
          </p>
          <p class="c7">
            <span class="c5">Any </span><span>E-commerce</span
            ><span class="c4"
              >&nbsp;or Payment Facilitator willing to take this route should be aware of
              the associated risks:</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >The MoR is an industry-standard categorization not formally recognised by
              the schemes. Visa and Mastercard reserve the right to determine the
              categorisation of a merchant.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >If flagged by the card schemes , they will be under the obligation to
              remediate their set up and may incur non-compliance assessments.</span
            >
          </p>
          <h2 class="c0" id="h.23gc3rrjpknv">
            <span class="c6 c2">PROHIBITED ACTIVITIES</span>
          </h2>
          <p class="c7">
            <span class="c4"
              >You may not access or use the Site for any purpose other than that for
              which we make the Site available. The Site may not be used in connection
              with any commercial endeavors except those that are specifically endorsed or
              approved by us.</span
            >
          </p>
          <p class="c7">
            <span class="c4">As a user of the Site, you agree not to:</span>
          </p>
          <ol class="c9 lst-kix_h7jy7wnsfc4k-0 start" start="1">
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Systematically retrieve data or other content from the Site to create or
                compile, directly or indirectly, a collection, compilation, database, or
                directory without written permission from us.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c5">Make any unauthorized use of the </span
              ><span>E-commerce</span
              ><span class="c4"
                >&nbsp;Offerings, including collecting usernames and/or email addresses of
                users by electronic or other means for the purpose of sending unsolicited
                email, or creating user accounts by automated means or under false
                pretenses.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Use a buying agent or purchasing agent to make purchases on the
                Site.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Circumvent, disable, or otherwise interfere with security-related
                features of the Site, including features that prevent or restrict the use
                or copying of any Content or enforce limitations on the use of the Site
                and/or the Content contained therein.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Engage in unauthorized framing of or linking to the Site.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Trick, defraud, or mislead us and other users, especially in any attempt
                to learn sensitive account information such as user passwords.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Make improper use of our support services or submit false reports of
                abuse or misconduct.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Engage in any automated use of the system, such as using scripts to send
                comments or messages, or using any data mining, robots, or similar data
                gathering and extraction tools.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Interfere with, disrupt, or create an undue burden on the Site or the
                networks or services connected to the Site.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Attempt to impersonate another user or person or use the username of
                another user.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4">Sell or otherwise transfer your profile.</span>
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Use any information obtained from the Site in order to harass, abuse, or
                harm another person.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c5">Use the </span><span>E-commerce</span
              ><span class="c4"
                >&nbsp;Offerings as part of any effort to compete with us or otherwise use
                the Site and/or the Content for any revenue-generating endeavor or
                commercial enterprise.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Decipher, decompile, disassemble, or reverse engineer any of the software
                comprising or in any way making up a part of the Site.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Attempt to bypass any measures of the Site designed to prevent or
                restrict access to the Site, or any portion of the Site.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c5"
                >Harass, annoy, intimidate, or threaten any of our employees or agents
                engaged in providing any portion of the </span
              ><span>E-commerce</span><span class="c4">&nbsp;Offerings to you.</span>
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Delete the copyright or other proprietary rights notice from any
                Content.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Copy or adapt the Site’s software, including but not limited to Flash,
                PHP, HTML, JavaScript, or other code.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c5"
                >Upload or transmit (or attempt to upload or to transmit) viruses, Trojan
                horses, or other material, including excessive use of capital letters and
                spamming (continuous posting of repetitive text), that interferes with any
                party’s uninterrupted use and enjoyment of the Site or modifies, impairs,
                disrupts, alters, or interferes with the use, features, functions,
                operation, or maintenance of the </span
              ><span>E-commerce</span><span class="c4">&nbsp;Offerings.</span>
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Upload or transmit (or attempt to upload or to transmit) any material
                that acts as a passive or active information collection or transmission
                mechanism, including without limitation, clear graphics interchange
                formats (“gifs”), 1×1 pixels, web bugs, cookies, or other similar devices
                (sometimes referred to as “spyware” or “passive collection mechanisms” or
                “pcms”).</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Except as may be the result of standard search engine or Internet browser
                usage, use, launch, develop, or distribute any automated system, including
                without limitation, any spider, robot, cheat utility, scraper, or offline
                reader that accesses the Site, or using or launching any unauthorized
                script or other software.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Disparage, tarnish, or otherwise harm, in our opinion, us and/or the
                Site.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Use the Site in a manner inconsistent with any applicable laws or
                regulations.</span
              >
            </li>
          </ol>
          <h2 class="c0" id="h.ncdiji63l83y">
            <span class="c2 c6">USER GENERATED CONTRIBUTIONS</span>
          </h2>
          <p class="c7">
            <span class="c5"
              >The Site may invite you to chat, contribute to, or participate in blogs,
              message boards, online forums, and other functionality, and may provide you
              with the opportunity to create, submit, post, display, transmit, perform,
              publish, distribute, or broadcast content and materials to us or on the
              Site, including but not limited to text, writings, video, audio,
              photographs, graphics, comments, suggestions, or personal information or
              other material (collectively, “Contributions”). Contributions may be
              viewable by other users of the Site and the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings and through third-party websites. As such, any
              Contributions you transmit may be treated as non-confidential and
              non-proprietary. When you create or make available any Contributions, you
              thereby represent and warrant that:</span
            >
          </p>
          <ol class="c9 lst-kix_nuc2ox8ivt4h-0 start" start="1">
            <li class="c1 li-bullet-0">
              <span class="c4"
                >The creation, distribution, transmission, public display, or performance,
                and the accessing, downloading, or copying of your Contributions do not
                and will not infringe the proprietary rights, including but not limited to
                the copyright, patent, trademark, trade secret, or moral rights of any
                third party.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >You are the creator and owner of or have the necessary licenses, rights,
                consents, releases, and permissions to use and to authorize us, the Site,
                and other users of the Site to use your Contributions in any manner
                contemplated by the Site and these Terms of Use.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >You have the written consent, release, and/or permission of each and
                every identifiable individual person in your Contributions to use the name
                or likeness of each and every such identifiable individual person to
                enable inclusion and use of your Contributions in any manner contemplated
                by the Site and these Terms of Use.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions are not false, inaccurate, or misleading.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions are not unsolicited or unauthorized advertising,
                promotional materials, pyramid schemes, chain letters, spam, mass
                mailings, or other forms of solicitation.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions are not obscene, lewd, lascivious, filthy, violent,
                harassing, libelous, slanderous, or otherwise objectionable (as determined
                by us).</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions do not ridicule, mock, disparage, intimidate, or abuse
                anyone.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions do not advocate the violent overthrow of any
                government or incite, encourage, or threaten physical harm against
                another.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions do not violate any applicable law, regulation, or
                rule.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions do not violate the privacy or publicity rights of any
                third party.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions do not contain any material that solicits personal
                information from anyone under the age of 18 or exploits people under the
                age of 18 in a sexual or violent manner.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions do not violate any applicable law concerning child
                pornography, or otherwise intended to protect the health or well-being of
                minors.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions do not include any offensive comments that are
                connected to race, national origin, gender, sexual preference, or physical
                handicap.</span
              >
            </li>
            <li class="c1 li-bullet-0">
              <span class="c4"
                >Your Contributions do not otherwise violate, or link to material that
                violates, any provision of these Terms of Use, or any applicable law or
                regulation.</span
              >
            </li>
          </ol>
          <p class="c7">
            <span class="c5">Any use of the Site or the </span><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings in violation of the foregoing violates these Terms of Use
              and may result in, among other things, termination or suspension of your
              rights to use the Site and the </span
            ><span>E-commerce</span><span class="c4">&nbsp;Offerings.</span>
          </p>
          <h2 class="c0" id="h.e26k7r8r4oyq">
            <span class="c6 c2">CONTRIBUTION LICENSE</span>
          </h2>
          <p class="c7">
            <span class="c4"
              >By posting your Contributions to any part of the Site or making
              Contributions accessible to the Site by linking your account from the Site
              to any of your social networking accounts, you automatically grant, and you
              represent and warrant that you have the right to grant, to us an
              unrestricted, unlimited, irrevocable, perpetual, non-exclusive,
              transferable, royalty-free, fully-paid, worldwide right, and license to
              host, use, copy, reproduce, disclose, sell, resell, publish, broadcast,
              retitle, archive, store, cache, publicly perform, publicly display,
              reformat, translate, transmit, excerpt (in whole or in part), and distribute
              such Contributions (including, without limitation, your image and voice) for
              any purpose, commercial, advertising, or otherwise, and to prepare
              derivative works of, or incorporate into other works, such Contributions,
              and grant and authorize sublicenses of the foregoing. The use and
              distribution may occur in any media formats and through any media
              channels.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >This license will apply to any form, media, or technology now known or
              hereafter developed, and includes our use of your name, company name, and
              franchise name, as applicable, and any of the trademarks, service marks,
              trade names, logos, and personal and commercial images you provide. You
              waive all moral rights in your Contributions, and you warrant that moral
              rights have not otherwise been asserted in your Contributions.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >We do not assert any ownership over your Contributions. You retain full
              ownership of all of your Contributions and any intellectual property rights
              or other proprietary rights associated with your Contributions. We are not
              liable for any statements or representations in your Contributions provided
              by you in any area on the Site. You are solely responsible for your
              Contributions to the Site and you expressly agree to exonerate us from any
              and all responsibility and to refrain from any legal action against us
              regarding your Contributions.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >We have the right, in our sole and absolute discretion, (1) to edit,
              redact, or otherwise change any Contributions; (2) to re-categorize any
              Contributions to place them in more appropriate locations on the Site; and
              (3) to pre-screen or delete any Contributions at any time and for any
              reason, without notice. We have no obligation to monitor your
              Contributions.</span
            >
          </p>
          <h2 class="c0" id="h.13kn7ktll4xy">
            <span class="c6 c2">GUIDELINES FOR REVIEWS</span>
          </h2>
          <p class="c7">
            <span class="c4"
              >We may provide you areas on the Site to leave reviews or ratings. When
              posting a review, you must comply with the following criteria: (1) you
              should have firsthand experience with the person/entity being reviewed; (2)
              your reviews should not contain offensive profanity, or abusive, racist,
              offensive, or hate language; (3) your reviews should not contain
              discriminatory references based on religion, race, gender, national origin,
              age, marital status, sexual orientation, or disability; (4) your reviews
              should not contain references to illegal activity; (5) you should not be
              affiliated with competitors if posting negative reviews; (6) you should not
              make any conclusions as to the legality of conduct; (7) you may not post any
              false or misleading statements; and (8) you may not organize a campaign
              encouraging others to post reviews, whether positive or negative.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >We may accept, reject, or remove reviews at our sole discretion. We have
              absolutely no obligation to screen reviews or to delete reviews, even if
              anyone considers reviews objectionable or inaccurate. Reviews are not
              endorsed by us, and do not necessarily represent our opinions or the views
              of any of our affiliates or partners. We do not assume liability for any
              review or for any claims, liabilities, or losses resulting from any review.
              By posting a review, you hereby grant to us a perpetual, non-exclusive,
              worldwide, royalty-free, fully-paid, assignable, and sublicensable right and
              license to reproduce, modify, translate, transmit by any means, display,
              perform, and/or distribute all content relating to reviews.</span
            >
          </p>
          <h2 class="c0" id="h.gaud8an0i9pf">
            <span class="c6 c2">MOBILE APPLICATION LICENSE</span>
          </h2>
          <h3 class="c25" id="h.2a2qsdwkncah"><span class="c8">Use License</span></h3>
          <p class="c7">
            <span class="c5">If you access the </span><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings via a mobile application, then we grant you a revocable,
              non-exclusive, non-transferable, limited right to install and use the mobile
              application on wireless electronic devices owned or controlled by you, and
              to access and use the mobile application on such devices strictly in
              accordance with the terms and conditions of this mobile application license
              contained in these Terms of Use. You shall not: (1) decompile, reverse
              engineer, disassemble, attempt to derive the source code of, or decrypt the
              application; (2) make any modification, adaptation, improvement,
              enhancement, translation, or derivative work from the application; (3)
              violate any applicable laws, rules, or regulations in connection with your
              access or use of the application; (4) remove, alter, or obscure any
              proprietary notice (including any notice of copyright or trademark) posted
              by us or the licensors of the application; (5) use the application for any
              revenue generating endeavor, commercial enterprise, or other purpose for
              which it is not designed or intended; (6) make the application available
              over a network or other environment permitting access or use by multiple
              devices or users at the same time; (7) use the application for creating a
              product, service, or software that is, directly or indirectly, competitive
              with or in any way a substitute for the application; (8) use the application
              to send automated queries to any website or to send any unsolicited
              commercial e-mail; or (9) use any proprietary information or any of our
              interfaces or our other intellectual property in the design, development,
              manufacture, licensing, or distribution of any applications, accessories, or
              devices for use with the application.</span
            >
          </p>
          <h2 class="c0" id="h.60k6j0937von">
            <span class="c6 c2">Apple and Android Devices</span>
          </h2>
          <p class="c7">
            <span class="c5"
              >The following terms apply when you use a mobile application obtained from
              either the Apple Store or Google Play (each an “App Distributor”) to access
              the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings: (1) the license granted to you for our mobile application
              is limited to a non-transferable license to use the application on a device
              that utilizes the Apple iOS or Android operating systems, as applicable, and
              in accordance with the usage rules set forth in the applicable App
              Distributor’s terms of service; (2) we are responsible for providing any
              maintenance and support services with respect to the mobile application as
              specified in the terms and conditions of this mobile application license
              contained in these Terms of Use or as otherwise required under applicable
              law, and you acknowledge that each App Distributor has no obligation
              whatsoever to furnish any maintenance and support services with respect to
              the mobile application; (3) in the event of any failure of the mobile
              application to conform to any applicable warranty, you may notify the
              applicable App Distributor, and the App Distributor, in accordance with its
              terms and policies, may refund the purchase price, if any, paid for the
              mobile application, and to the maximum extent permitted by applicable law,
              the App Distributor will have no other warranty obligation whatsoever with
              respect to the mobile application; (4) you represent and warrant that (i)
              you are not located in a country that is subject to a U.S. government
              embargo, or that has been designated by the U.S. government as a “terrorist
              supporting” country and (ii) you are not listed on any U.S. government list
              of prohibited or restricted parties; (5) you must comply with applicable
              third-party terms of agreement when using the mobile application, e.g., if
              you have a VoIP application, then you must not be in violation of their
              wireless data service agreement when using the mobile application; and (6)
              you acknowledge and agree that the App Distributors are third-party
              beneficiaries of the terms and conditions in this mobile application license
              contained in these Terms of Use, and that each App Distributor will have the
              right (and will be deemed to have accepted the right) to enforce the terms
              and conditions in this mobile application license contained in these Terms
              of Use against you as a third-party beneficiary thereof.</span
            >
          </p>
          <h2 class="c0" id="h.3sm6y419e6ev"><span class="c6 c2">SOCIAL MEDIA</span></h2>
          <p class="c7">
            <span class="c4"
              >As part of the functionality of the Site, you may link your account with
              online accounts you have with third-party service providers (each such
              account, a “Third-Party Account”) by either: (1) providing your Third-Party
              Account login information through the Site; or (2) allowing us to access
              your Third-Party Account, as is permitted under the applicable terms and
              conditions that govern your use of each Third-Party Account. You represent
              and warrant that you are entitled to disclose your Third-Party Account login
              information to us and/or grant us access to your Third-Party Account,
              without breach by you of any of the terms and conditions that govern your
              use of the applicable Third-Party Account, and without obligating us to pay
              any fees or making us subject to any usage limitations imposed by the
              third-party service provider of the Third-Party Account. By granting us
              access to any Third-Party Accounts, you understand that (1) we may access,
              make available, and store (if applicable) any content that you have provided
              to and stored in your Third-Party Account (the “Social Network Content”) so
              that it is available on and through the Site via your account, including
              without limitation any friend lists and (2) we may submit to and receive
              from your Third-Party Account additional information to the extent you are
              notified when you link your account with the Third-Party Account. Depending
              on the Third-Party Accounts you choose and subject to the privacy settings
              that you have set in such Third-Party Accounts, personally identifiable
              information that you post to your Third-Party Accounts may be available on
              and through your account on the Site. Please note that if a Third-Party
              Account or associated service becomes unavailable or our access to such
              Third-Party Account is terminated by the third-party service provider, then
              Social Network Content may no longer be available on and through the Site.
              You will have the ability to disable the connection between your account on
              the Site and your Third-Party Accounts at any time. PLEASE NOTE THAT YOUR
              RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED WITH YOUR
              THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH
              THIRD-PARTY SERVICE PROVIDERS. We make no effort to review any Social
              Network Content for any purpose, including but not limited to, for accuracy,
              legality, or non-infringement, and we are not responsible for any Social
              Network Content. You acknowledge and agree that we may access your email
              address book associated with a Third-Party Account and your contacts list
              stored on your mobile device or tablet computer solely for purposes of
              identifying and informing you of those contacts who have also registered to
              use the Site. You can deactivate the connection between the Site and your
              Third-Party Account by contacting us using the contact information below or
              through your account settings (if applicable). We will attempt to delete any
              information stored on our servers that was obtained through such Third-Party
              Account, except the username and profile picture that become associated with
              your account.</span
            >
          </p>
          <h2 class="c0" id="h.8k7ugi3f6glm"><span class="c6 c2">SUBMISSIONS</span></h2>
          <p class="c7">
            <span class="c5"
              >You acknowledge and agree that any questions, comments, suggestions, ideas,
              feedback, or other information regarding the Site or the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings (“Submissions”) provided by you to us are non-confidential
              and shall become our sole property. We shall own exclusive rights, including
              all intellectual property rights, and shall be entitled to the unrestricted
              use and dissemination of these Submissions for any lawful purpose,
              commercial or otherwise, without acknowledgment or compensation to you. You
              hereby waive all moral rights to any such Submissions, and you hereby
              warrant that any such Submissions are original with you or that you have the
              right to submit such Submissions. You agree there shall be no recourse
              against us for any alleged or actual infringement or misappropriation of any
              proprietary right in your Submissions.</span
            >
          </p>
          <h2 class="c0" id="h.a4pho1jpqa9o">
            <span class="c6 c2">SITE MANAGEMENT</span>
          </h2>
          <p class="c7">
            <span class="c5"
              >We reserve the right, but not the obligation, to: (1) monitor the Site for
              violations of these Terms of Use; (2) take appropriate legal action against
              anyone who, in our sole discretion, violates the law or these Terms of Use,
              including without limitation, reporting such user to law enforcement
              authorities; (3) in our sole discretion and without limitation, refuse,
              restrict access to, limit the availability of, or disable (to the extent
              technologically feasible) any of your Contributions or any portion thereof;
              (4) in our sole discretion and without limitation, notice, or liability, to
              remove from the Site or otherwise disable all files and content that are
              excessive in size or are in any way burdensome to our systems; and (5)
              otherwise manage the Site in a manner designed to protect our rights and
              property and to facilitate the proper functioning of the Site and the </span
            ><span>E-commerce</span><span class="c4">&nbsp;Offerings.</span>
          </p>
          <h2 class="c0" id="h.r1mkewjz9mk9">
            <span class="c6 c2">PRIVACY POLICY</span>
          </h2>
          <p class="c7">
            <span class="c5"
              >We care about data privacy and security. Please review our Privacy Policy: </span
            ><span class="c19 c12"
              ><a
                class="c18"
                href="https://www.google.com/url?q=https://www.popsy.app/privacy-policy?lang%3Den&amp;sa=D&amp;source=editors&amp;ust=1680258966941686&amp;usg=AOvVaw0zlrz-NA677PQxzEJg0Hh7"
                >https://www.popsy.app/privacy-policy?lang=en</a
              ></span
            ><span class="c5">. By using the Site or the </span><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings, you agree to be bound by our Privacy Policy, which is
              incorporated into these Terms of Use. Please be advised the Site and the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings are hosted in the United Arab Emirates. If you access the
              Site or the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings from any other region of the world with laws or other
              requirements governing personal data collection, use, or disclosure that
              differ from applicable laws in the United Arab Emirates, then through your
              continued use of the Site, you are transferring your data to United Arab
              Emirates,, and you agree to have your data transferred to and processed in
              United Arab Emirates.</span
            >
          </p>
          <h2 class="c0" id="h.9s8gjtcuyw4q">
            <span class="c6 c2">COPYRIGHT INFRINGEMENTS</span>
          </h2>
          <p class="c7">
            <span class="c4"
              >We respect the intellectual property rights of others. If you believe that
              any material available on or through the Site infringes upon any copyright
              you own or control, please immediately notify us using the contact
              information provided below (a “Notification”). A copy of your Notification
              will be sent to the person who posted or stored the material addressed in
              the Notification. Please be advised that pursuant to applicable law you may
              be held liable for damages if you make material misrepresentations in a
              Notification. Thus, if you are not sure that material located on or linked
              to by the Site infringes your copyright, you should consider first
              contacting an attorney.</span
            >
          </p>
          <h2 class="c0" id="h.jw1zk8tl60me">
            <span class="c6 c2">TERM AND TERMINATION</span>
          </h2>
          <p class="c7">
            <span class="c5"
              >These Terms of Use shall remain in full force and effect while you use the
              Site. WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS OF USE, WE RESERVE
              THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY
              ACCESS TO AND USE OF THE SITE AND THE </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;OFFERINGS (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON
              FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF
              ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE TERMS OF USE OR
              OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR
              PARTICIPATION IN THE SITE AND THE </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;OFFERINGS OR DELETE YOUR ACCOUNT AND ANY CONTENT OR INFORMATION THAT
              YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.</span
            >
          </p>
          <p class="c7">
            <span class="c4"
              >If we terminate or suspend your account for any reason, you are prohibited
              from registering and creating a new account under your name, a fake or
              borrowed name, or the name of any third party, even if you may be acting on
              behalf of the third party. In addition to terminating or suspending your
              account, we reserve the right to take appropriate legal action, including
              without limitation pursuing civil, criminal, and injunctive redress.</span
            >
          </p>
          <h2 class="c0" id="h.9t7b9dcvayy6">
            <span class="c6 c2">MODIFICATIONS AND INTERRUPTIONS</span>
          </h2>
          <p class="c7">
            <span class="c5"
              >We reserve the right to change, modify, or remove the contents of the Site
              at any time or for any reason at our sole discretion without notice.
              However, we have no obligation to update any information on our Site. We
              also reserve the right to modify or discontinue all or part of the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings without notice at any time. We will not be liable to you or
              any third party for any modification, price change, suspension, or
              discontinuance of the Site or the </span
            ><span>E-commerce</span><span class="c4">&nbsp;Offerings.</span>
          </p>
          <p class="c7">
            <span class="c5">We cannot guarantee the Site and the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings will be available at all times. We may experience hardware,
              software, or other problems or need to perform maintenance related to the
              Site, resulting in interruptions, delays, or errors. We reserve the right to
              change, revise, update, suspend, discontinue, or otherwise modify the Site
              or the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings at any time or for any reason without notice to you. You
              agree that we have no liability whatsoever for any loss, damage, or
              inconvenience caused by your inability to access or use the Site or the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings during any downtime or discontinuance of the Site or the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings. Nothing in these Terms of Use will be construed to
              obligate us to maintain and support the Site or the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings or to supply any corrections, updates, or releases in
              connection therewith.</span
            >
          </p>
          <h2 class="c0" id="h.jngzeyas87cu"><span class="c6 c2">GOVERNING LAW</span></h2>
          <p class="c7">
            <span class="c4"
              >These terms shall be governed by and defined following the laws of United
              Arab Emirates. Popsy LLC and yourself irrevocably consent that the courts of
              the United Arab Emirates shall have exclusive jurisdiction to resolve any
              dispute which may arise in connection with these terms.</span
            >
          </p>
          <h2 class="c0" id="h.1toids4epfcv">
            <span class="c6 c2">DISPUTE RESOLUTION</span>
          </h2>
          <p class="c7">
            <span class="c4"
              >You agree to irrevocably submit all disputes related to Terms or the
              relationship established by this Agreement to the jurisdiction of the United
              Arab Emirates courts. Popsy LLC shall also maintain the right to bring
              proceedings as to the substance of the matter in the courts of the country
              where you reside or, if these Terms are entered into in the course of your
              trade or profession, the state of your principal place of business.</span
            >
          </p>
          <h2 class="c0" id="h.tc2vq46mulac"><span class="c6 c2">CORRECTIONS</span></h2>
          <p class="c7">
            <span class="c5"
              >There may be information on the Site that contains typographical errors,
              inaccuracies, or omissions that may relate to the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings, including descriptions, pricing, availability, and various
              other information. We reserve the right to correct any errors, inaccuracies,
              or omissions and to change or update the information on the Site at any
              time, without prior notice.</span
            >
          </p>
          <h2 class="c0" id="h.r5pjhei3p9lb"><span class="c6 c2">DISCLAIMER</span></h2>
          <p class="c7">
            <span class="c5">THE SITE AND THE </span><span>E-commerce</span
            ><span class="c5"
              >&nbsp;OFFERINGS ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE
              THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR SOLE RISK. TO THE
              FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR
              IMPLIED, IN CONNECTION WITH THE SITE AND THE </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;OFFERINGS AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
              NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE
              ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY
              WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR
              RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND
              MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
              RESULTING FROM YOUR ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED
              ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL
              INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY
              INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE OR THE </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;OFFERINGS, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH
              MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY
              ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE
              OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED,
              TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT,
              ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE
              ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED
              WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR
              OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE
              RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY
              PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR
              SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST
              JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.</span
            >
          </p>
          <h2 class="c0" id="h.6nvd0s9yekso">
            <span class="c6 c2">LIMITATIONS OF LIABILITY</span>
          </h2>
          <p class="c7">
            <span class="c5"
              >IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU
              OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY,
              INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST
              REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE OR
              THE </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;OFFERINGS, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGES. NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR
              LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE
              ACTION, WILL AT ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO
              US. CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON
              IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF
              THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS
              MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.</span
            >
          </p>
          <h2 class="c0" id="h.25ntati0uiqf">
            <span class="c6 c2">INDEMNIFICATION</span>
          </h2>
          <p class="c7">
            <span class="c5"
              >You agree to defend, indemnify, and hold us harmless, including our
              subsidiaries, affiliates, and all of our respective officers, agents,
              partners, and employees, from and against any loss, damage, liability,
              claim, or demand, including reasonable attorneys’ fees and expenses, made by
              any third party due to or arising out of: (1) your Contributions; (2) use of
              the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings; (3) breach of these Terms of Use; (4) any breach of your
              representations and warranties set forth in these Terms of Use; (5) your
              violation of the rights of a third party, including but not limited to
              intellectual property rights; or (6) any overt harmful act toward any other
              user of the Site or the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings with whom you connected via the Site. Notwithstanding the
              foregoing, we reserve the right, at your expense, to assume the exclusive
              defense and control of any matter for which you are required to indemnify
              us, and you agree to cooperate, at your expense, with our defense of such
              claims. We will use reasonable efforts to notify you of any such claim,
              action, or proceeding which is subject to this indemnification upon becoming
              aware of it.</span
            >
          </p>
          <h2 class="c0" id="h.rca6c6vkohfe"><span class="c6 c2">USER DATA</span></h2>
          <p class="c7">
            <span class="c5"
              >We will maintain certain data that you transmit to the Site for the purpose
              of managing the performance of the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings, as well as data relating to your use of the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings. Although we perform regular routine backups of data, you
              are solely responsible for all data that you transmit or that relates to any
              activity you have undertaken using the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings. You agree that we shall have no liability to you for any
              loss or corruption of any such data, and you hereby waive any right of
              action against us arising from any such loss or corruption of such
              data.</span
            >
          </p>
          <h2 class="c0" id="h.qrqblnesmtaw">
            <span class="c6 c2"
              >ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</span
            >
          </h2>
          <p class="c7">
            <span class="c4"
              >Visiting the Site, sending us emails, and completing online forms
              constitute electronic communications. You consent to receive electronic
              communications, and you agree that all agreements, notices, disclosures, and
              other communications we provide to you electronically, via email and on the
              Site, satisfy any legal requirement that such communication be in writing.
              YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND
              OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS
              OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE. You hereby
              waive any rights or requirements under any statutes, regulations, rules,
              ordinances, or other laws in any jurisdiction which require an original
              signature or delivery or retention of non-electronic records, or to payments
              or the granting of credits by any means other than electronic means.</span
            >
          </p>
          <h2 class="c0" id="h.qq72d3j44slb"><span class="c6 c2">MISCELLANEOUS</span></h2>
          <p class="c7">
            <span class="c5"
              >These Terms of Use and any policies or operating rules posted by us on the
              Site or in respect to the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings constitute the entire agreement and understanding between
              you and us. Our failure to exercise or enforce any right or provision of
              these Terms of Use shall not operate as a waiver of such right or provision.
              These Terms of Use operate to the fullest extent permissible by law. We may
              assign any or all of our rights and obligations to others at any time. We
              shall not be responsible or liable for any loss, damage, delay, or failure
              to act caused by any cause beyond our reasonable control. If any provision
              or part of a provision of these Terms of Use is determined to be unlawful,
              void, or unenforceable, that provision or part of the provision is deemed
              severable from these Terms of Use and does not affect the validity and
              enforceability of any remaining provisions. There is no joint venture,
              partnership, employment or agency relationship created between you and us as
              a result of these Terms of Use or use of the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings. You agree that these Terms of Use will not be construed
              against us by virtue of having drafted them. You hereby waive any and all
              defenses you may have based on the electronic form of these Terms of Use and
              the lack of signing by the parties hereto to execute these Terms of
              Use.</span
            >
          </p>
          <h2 class="c0" id="h.5v3dtq16kuuv"><span class="c6 c2">CONTACT US</span></h2>
          <p class="c7">
            <span class="c5"
              >In order to resolve a complaint regarding the Site or the </span
            ><span>E-commerce</span
            ><span class="c5"
              >&nbsp;Offerings or to receive further information regarding use of the Site
              or the </span
            ><span>E-commerce</span
            ><span class="c4"
              >&nbsp;Offerings, please contact us at: support&#64;popsy.app</span
            >
          </p>
          <p class="c7"><span class="c4">Read our full FAQ at:</span></p>
          <p class="c7"><span class="c4">English</span></p>
          <p class="c7">
            <span class="c19"
              ><a
                class="c18"
                href="https://www.google.com/url?q=https://www.popsy.app/faq?lang=en&amp;sa=D&amp;source=editors&amp;ust=1680258966947990&amp;usg=AOvVaw2xNgaHaVWncwubZ0A123lJ"
                >https://us.popsy.app/faq</a
              ></span
            >
          </p>
          <p class="c7"><span>Arabic</span></p>
          <p class="c7">
            <span class="c19"
              ><a
                class="c18"
                href="https://www.google.com/url?q=https://ae.popsy.app/faq&amp;sa=D&amp;source=editors&amp;ust=1680258966948457&amp;usg=AOvVaw0npn6wcznQqfJGA9mf2UVt"
                >https://ae.popsy.app/faq</a
              ></span
            >
          </p>
          <p class="c7 c13"><span class="c4"></span></p>
        </section>
        <section *ngIf="lang === 'AR'">
          <h1 class="c7" dir="rtl" id="h.exij5bfsu05u">
            <span class="c14">شروط الاستخدام</span>
          </h1>
          <p class="c20" dir="rtl"><span class="c0">آخر تحديث 23 فبراير 2023</span></p>
          <ul class="c3 lst-kix_ghbdd5dimn1c-0 start">
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c8 c2"
                >يخضع هذا الموقع لقانون دولة الإمارات العربية المتحدة في ما يتعلق بأي
                نزاعات أو مطالبات تنشأ عنه أو تتعلق به.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c8 c2"
                >يُحظر على المستخدمين الذين تقل أعمارهم عن 18 عامًا التسجيل كمستخدمين لهذا
                الموقع ولا يمكنهم التعامل أو استخدام الموقع.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c8 c2"
                >نحن نستخدم اتصالاً آمنًا للاتصال مباشرة بمزود الدفع الخاص بنا إذا قمت
                بالدفع مقابل منتجاتنا أو خدماتنا على موقعنا الإلكتروني.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c8 c2"
                >يجب على حامل البطاقة الاحتفاظ بنسخة من سجلات المعاملات وسياسات وقواعد
                التاجر.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c8 c2"
                >نقبل المدفوعات عبر الإنترنت باستخدام بطاقة الائتمان / الخصم Visa و
                MasterCard بالعملة المحلية ، أو عبر أي من مزودي خدمة التقسيط لدينا</span
              >
            </li>
          </ul>
          <h2 class="c6" dir="rtl" id="h.uv0qtrk15fq7">
            <span class="c1">الموافقة على الشروط</span>
          </h2>
          <p class="c5" dir="rtl">
            <span
              >تشكل شروط الاستخدام هذه اتفاقية ملزمة قانونًا بينك ، سواء شخصيًا أو نيابة
              عن كيان ("أنت") وشركة Popsy LLC ("الشركة" أو "نحن" أو "نحن" أو "الخاصة بنا")
              ، فيما يتعلق بك الوصول إلى واستخدام</span
            ><span
              ><a
                class="c11"
                href="https://www.google.com/url?q=https://www.popsy.app/&amp;sa=D&amp;source=editors&amp;ust=1680259268371404&amp;usg=AOvVaw2iKbXch_ZfSalhIXNy5kH3"
                >https://www.popsy.app</a
              ></span
            ><span class="c0"
              >&nbsp;موقع الويب بالإضافة إلى أي نموذج وسائط آخر أو قناة إعلامية أو موقع
              ويب للجوال أو تطبيق جوال مرتبط أو مرتبط به أو متصل به بطريقة أخرى (يشار
              إليها إجمالاً بـ "الموقع"). يوفر الموقع التجارة الإلكترونية للسلع العامة و /
              أو المنتجات و / أو الخدمات ("عروض التجارة الإلكترونية"). للمساعدة في جعل
              الموقع بيئة آمنة لشراء وبيع عروض التجارة الإلكترونية ، يتعين على جميع
              المستخدمين قبول شروط الاستخدام هذه والامتثال لها. أنت توافق على أنه من خلال
              الوصول إلى الموقع و / أو عروض التجارة الإلكترونية ، تكون قد قرأت وفهمت
              وتوافق على الالتزام بجميع شروط الاستخدام هذه. إذا كنت لا توافق على جميع شروط
              الاستخدام هذه ، فأنت ممنوع صراحةً من استخدام الموقع و / أو عروض التجارة
              الإلكترونية ويجب عليك التوقف عن استخدامه فورًا.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >الشروط والأحكام التكميلية أو المستندات التي قد يتم نشرها على الموقع من وقت
              لآخر مدرجة بموجب هذا صراحةً هنا بالإشارة إليها. نحتفظ بالحق ، وفقًا لتقديرنا
              الخاص ، في إجراء تغييرات أو تعديلات على شروط الاستخدام هذه في أي وقت ولأي
              سبب. سننبهك بأي تغييرات عن طريق تحديث تاريخ "آخر تحديث" لشروط الاستخدام هذه
              ، وأنت تتنازل عن أي حق في تلقي إشعار محدد لكل تغيير من هذا القبيل. تقع على
              عاتقك مسؤولية مراجعة شروط الاستخدام هذه بشكل دوري للبقاء على اطلاع على
              التحديثات. ستخضع للتغييرات في أي شروط استخدام معدلة من خلال استمرار استخدامك
              للموقع بعد تاريخ نشر شروط الاستخدام المعدلة هذه ، وستعتبر أنك قد علمت بها
              وقبلتها.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >المعلومات المقدمة على الموقع غير مخصصة للتوزيع أو الاستخدام من قبل أي شخص
              أو كيان في أي ولاية قضائية أو دولة يكون فيها هذا التوزيع أو الاستخدام
              مخالفًا للقانون أو اللوائح أو من شأنه أن يُخضعنا لأي شرط تسجيل داخل هذه
              الولاية القضائية أو الدولة . وبناءً على ذلك ، فإن هؤلاء الأشخاص الذين
              يختارون الوصول إلى الموقع من مواقع أخرى يفعلون ذلك بمبادرتهم الخاصة وهم
              وحدهم المسؤولون عن الامتثال للقوانين المحلية ، إذا كانت القوانين المحلية
              قابلة للتطبيق وإلى الحد الأقصى.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >الموقع مخصص للمستخدمين الذين لا تقل أعمارهم عن 13 عامًا. يجب أن يحصل جميع
              المستخدمين القصر في الولاية القضائية التي يقيمون فيها (بشكل عام أقل من 18
              عامًا) على إذن من والديهم أو الوصي عليهم ، ويشرف عليهم مباشرة لاستخدام
              الموقع. إذا كنت قاصرًا ، يجب أن يقرأ والديك أو ولي أمرك ويوافق على شروط
              الاستخدام هذه قبل استخدامك للموقع.</span
            >
          </p>
          <h2 class="c6 c13" dir="rtl" id="h.wirxivdxdufc">
            <span class="c1">سياسة الإلغاء</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c8 c2"
              >عند تقديم طلب الإلغاء ، ستتم مراجعة حالة الطلب. إذا تم إرسال الطلب بالفعل ،
              يجب على العميل دفع رسوم الشحن من أجل إلغائه
            </span>
          </p>
          <p class="c5" dir="rtl">
            <span class="c8 c2"
              >ملاحظة المشتريات التي تتم باستخدام كوارا (Quara) بعد إتمام المعاملة. لا
              ينطبق الاسترداد على المعاملات التي تتم من خلال كوارا. جميع المبيعات نهائية.
            </span>
          </p>
          <h2 class="c6 c13" dir="rtl" id="h.xpoffqm638u3">
            <span class="c1">سياسة الشحن والتسليم</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c8 c2"
              >الشحن مجاني ، حيث يتم شحن العناصر ما بين يومين إلى ثلاثة أيام حسب المخزون
              المتوفر لدى المورد. تتراوح تقديرات التسليم في غضون 5-7 أيام تقريبًا.</span
            >
            <span class="c8 c2">
              سيتم فرض رسوم بنسبة 100% من قيمة الطلب على العملاء الذين يرفضون استلام
              طلباتهم، حيث يكون المنتج قد تم شحنه بالفعل. إذا رغب العميل في إلغاء الطلب
              بعد شحنه، يتوجب عليه استلام المنتج أولاً ثم تقديم طلب إرجاع من خلال
              الإجراءات المحددة ليكون مؤهلاً لاسترداد المبلغ بالكامل. تهدف هذه السياسة إلى
              ضمان إدارة فعالة للطلبات وتقليل التعطيل في العمليات.
            </span>
          </p>
          <h2 class="c6 c13" dir="rtl" id="h.dm5372crbzjw">
            <span class="c1">سياسة الاسترداد والاستبدال</span>
          </h2>
          <p class="c12" dir="rtl">
            <span class="c8 c2"
              >يمكنك طلب إرجاع / استبدال / استرداد في غضون 14 يومًا بعد استلام المنتج
              و:</span
            >
          </p>
          <p class="c10" dir="rtl">
            <span class="c2">1.</span
            ><span class="c2 c14">&nbsp;إذا تلقيت منتجًا غير صحيح</span
            ><span class="c8 c2"
              >&nbsp;(طالما لم يتم استخدام المنتج وشمل جميع العلامات والعبوة الأصلية غير
              التالفة). أو</span
            >
          </p>
          <p class="c10" dir="rtl">
            <span class="c2">2. إذا تلقيت ملف</span
            ><span class="c2 c14">&nbsp;المنتج التالف أو إذا كان لا يعمل بشكل صحيح</span
            ><span class="c2"
              >. سوف تحتاج إلى تقديم الصور ومقاطع الفيديو مع هذه المشكلة. يجب أن يشتمل
              المنتج على جميع العلامات والعبوات الأصلية غير التالفة. يجب الإبلاغ عن إعادة
              الجهاز التالف في غضون ثلاثة</span
            ><span class="c2 c14">&nbsp;أيام عمل للتسليم.</span>
          </p>
          <p class="c10" dir="rtl">
            <span class="c2"
              >إذا كنت ترغب في إرجاع منتج لا يتناسب مع أي من الأسباب المذكورة أعلاه
              ،</span
            ><span class="c18 c2 c14">&nbsp;قد تكون رسوم الإرجاع قابلة للتطبيق.</span>
          </p>

          <p class="c12" dir="rtl">
            <span class="c8 c2">يتم قبول المرتجعات فقط إذا:</span>
          </p>
          <p class="c10" dir="rtl">
            <span class="c8 c2"
              >1. تقوم بشحن المنتج مع عبوته الأصلية وعلاماته الأصلية غير التالفة ؛</span
            >
          </p>
          <p class="c10" dir="rtl">
            <span class="c8 c2">2. يتم تضمين كافة الملحقات</span>
          </p>
          <p class="c10" dir="rtl">
            <span class="c8 c2"
              >3. إذا كانت العبوة بها أضرار طفيفة ، أو إذا لم يُظهر العنصر المشكلات التي
              تم الإبلاغ عنها مسبقًا ، فسيتم خصم رسوم إعادة التخزين بنسبة 25٪ (النسبة
              المئوية) أثناء إجراء الاستبدال / رد الأموال.</span
            >
          </p>
          <p class="c10" dir="rtl">
            <span class="c2">4. يجب عليك إرسال المنتج</span
            ><span class="c2 c14">بدون</span
            ><span class="c8 c2">&nbsp;تسجيل الدخول (Apple ، Google ، إلخ).</span>
          </p>
          <p class="c10" dir="rtl">
            <span class="c8 c2">ما هي المنتجات التي لا يمكنني إرجاعها؟</span>
          </p>
          <p class="c10" dir="rtl">
            <span class="c8 c2"
              >1. المنتجات التي استخدمتها أو تعرضت للتلف أو ليست في نفس الحالة التي
              تلقيتها ؛</span
            >
          </p>
          <p class="c10" dir="rtl">
            <span class="c8 c2">2. أي منتج استهلاكي تم استخدامه أو تركيبه ؛</span>
          </p>
          <p class="c10" dir="rtl">
            <span class="c8 c2"
              >3. المنتجات ذات الأرقام التسلسلية التلاعب بها أو المفقودة</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c8 c2"
              >عند الاستلام الناجح ، سيقوم المستودع لدينا بفحص المنتج الذي تم شراؤه ،
              وتحديد ما إذا كان مؤهلاً لاسترداد الأموال ، ثم معالجة عملية الاسترداد وفقًا
              لطريقة الدفع. يحتفظ Popsy بالحق في رفض طلب إرجاع منتج وإرساله مرة أخرى إلى
              العميل في حالة عدم استيفاء المنتج المرتجع لأي من معايير الإرجاع الموضحة
              أعلاه.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c8 c2"
              >في حالة رفض طلب إرجاع المنتج ، ستقوم Popsy بمحاولتين لإعادة المنتج إلى
              العميل عبر خدمات البريد السريع المعتمدة. إذا لم تنجح كلتا محاولتي التسليم ،
              فسيحتفظ Popsy بالمنتج لمدة ثلاثة (3) أيام عمل في مركز التسليم الخاص به. في
              غضون ثلاثة (3) أيام عمل بعد المحاولة الأخيرة ، يمكن للعميل طلب محاولة أخرى
              مع فريق دعم العملاء لدينا. تفرض خدمة Popsy رسومًا قدرها 100 درهم إماراتي /
              ريال سعودي كرسوم عائد يتكبدها العميل. إذا لم يطالب العميل بالمنتج ، فسيتم
              إرساله للتصفية ولن يتمكن العميل من طلب إعادة المنتج مرة أخرى. لن يكون Popsy
              مسؤولاً أو مسؤولاً تجاه العميل. لا يحق للعملاء الحصول على أي تعويض.</span
            >
          </p>
          <h2 class="c6 c13" dir="rtl" id="h.745n1hsl7wx2"><span>ضمان</span></h2>
          <p class="c5" dir="rtl">
            <span class="c8 c2"
              >ستحتاج إلى تقديم طلب ضمان إلى فريق خدمة العملاء لدينا ، والذي سيتواصل معك
              وسيقدم لك بطاقة إرجاع مجانية في أقرب وقت ممكن. سيُطلب منك تقديم تفاصيل عن
              الشراء والعيب. بمجرد استلامنا للمنتج المرتجع ، سيتم فحصه وإصلاحه / استبداله.
              في حالة عدم إمكانية الإصلاح أو الاستبدال ، سنقوم بترتيب استرداد جزئي أو كامل
              للمنتج نقدًا أو رصيد المتجر. نهدف إلى تسوية جميع مطالباتنا في غضون 10 أيام
              عمل.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c2 c8"
              >يرجى ملاحظة أنه لا يمكن إرسال الأجهزة التي تم إصلاحها أو الاستبدال إلا بعد
              الفحص والإصلاح. أنت مسؤول عن تعبئة الجهاز بشكل آمن للشحن. يتحمل المرسل
              مسؤولية أي ضرر أو خسارة أثناء النقل.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c8 c2">ما الذي لا تغطيه سياسة الضمان؟</span>
          </p>
          <p class="c5" dir="rtl">
            <span class="c8 c2"
              >- أي ضرر أو عطل ناجم عن دخول السائل أو ناجم عنه مباشرة</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c8 c2"
              >- البلى والتلف التدريجي والأضرار التجميلية التي لا تؤثر على وظائف
              الجهاز</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c8 c2">- أي أضرار ناتجة عن الإهمال أو سوء التصرف المتعمد</span>
          </p>
          <p class="c5" dir="rtl">
            <span class="c8 c2">- أي فقدان / حذف / تلف لأي بيانات مخزنة على الجهاز</span>
          </p>
          <p class="c5" dir="rtl">
            <span class="c2"
              >قد تستغرق الإصلاحات ما يصل إلى 10 أيام عمل حسب نوع العيب ومستوى الإصلاح ،
              باستثناء وقت إعادة الشحن. في حالة عدم توفر قطع الغيار ، قد يكون الجدول
              الزمني للإصلاح أطول من 10 أيام.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.79oujr5214jh">
            <span class="c1">حقوق الملكية الفكرية</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >ما لم تتم الإشارة إلى خلاف ذلك ، فإن الموقع وعروض التجارة الإلكترونية هي
              ملكية خاصة بنا وجميع التعليمات البرمجية المصدر وقواعد البيانات والوظائف
              والبرامج وتصميمات مواقع الويب والصوت والفيديو والنصوص والصور الفوتوغرافية
              والرسومات على الموقع (يشار إليها مجتمعة باسم "المحتوى") و العلامات التجارية
              وعلامات الخدمة والشعارات الواردة فيها ("العلامات") مملوكة لنا أو خاضعة
              لسيطرتنا أو مرخصة لنا ، وهي محمية بموجب قوانين حقوق النشر والعلامات التجارية
              ومختلف حقوق الملكية الفكرية الأخرى وقوانين المنافسة غير العادلة لدولة
              الإمارات العربية المتحدة ، وقوانين حقوق النشر الدولية ، والاتفاقيات الدولية.
              يتم توفير المحتوى والعلامات على الموقع "كما هي" لمعلوماتك واستخدامك الشخصي
              فقط. باستثناء ما هو منصوص عليه صراحةً في شروط الاستخدام هذه ، لا يجوز نسخ أي
              جزء من الموقع أو عروض التجارة الإلكترونية ولا أي محتوى أو علامات أو إعادة
              إنتاجها أو تجميعها أو إعادة نشرها أو تحميلها أو نشرها أو عرضها علنًا أو
              ترميزها أو ترجمتها أو نقلها أو توزيعها أو بيعها أو مرخّصًا أو تم استغلاله
              بأي شكل آخر لأي غرض تجاري على الإطلاق ، دون إذن كتابي صريح مسبق منا.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >شريطة أن تكون مؤهلاً لاستخدام الموقع ، يتم منحك ترخيصًا محدودًا للوصول إلى
              الموقع واستخدامه وتنزيل أو طباعة نسخة من أي جزء من المحتوى الذي حصلت على حق
              الوصول إليه بشكل صحيح فقط لأغراضك الشخصية غير التجارية يستخدم. نحتفظ بجميع
              الحقوق غير الممنوحة لك صراحةً في الموقع والمحتوى والعلامات.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.rsta112bh45j">
            <span class="c1">إقرارات المستخدم</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >باستخدام الموقع أو عروض التجارة الإلكترونية ، فإنك تقر وتضمن أن: (1) جميع
              معلومات التسجيل التي ترسلها ستكون صحيحة ودقيقة وحديثة وكاملة ؛ (2) ستحافظ
              على دقة هذه المعلومات وتقوم بتحديث معلومات التسجيل على الفور حسب الضرورة ؛
              (3) لديك الأهلية القانونية وتوافق على الامتثال لشروط الاستخدام هذه ؛ (4) لم
              يكن عمرك أقل من 13 عامًا ؛ (5) لست قاصرًا في الولاية القضائية التي تقيم فيها
              ، أو إذا كنت قاصرًا ، فقد تلقيت إذنًا من الوالدين لاستخدام الموقع ؛ (6) لن
              تتمكن من الوصول إلى الموقع أو عروض التجارة الإلكترونية من خلال وسائل آلية أو
              غير بشرية ، سواء من خلال روبوت أو نص برمجي أو غير ذلك ؛ (7) لن تستخدم الموقع
              لأي غرض غير قانوني أو غير مصرح به ؛ و (8) لن ينتهك استخدامك للموقع أو عروض
              التجارة الإلكترونية أي قانون أو لائحة معمول بها.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >إذا قدمت أي معلومات غير صحيحة أو غير دقيقة أو غير حديثة أو غير كاملة ، فيحق
              لنا تعليق حسابك أو إنهائه ورفض أي وجميع الاستخدامات الحالية أو المستقبلية
              للموقع (أو أي جزء منه).</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >لا يجوز لك استخدام الموقع أو عروض التجارة الإلكترونية لأي غرض غير قانوني أو
              غير مصرح به ولا يجوز لك ، في استخدام عروض التجارة الإلكترونية ، انتهاك أي
              قوانين. من بين عروض التجارة الإلكترونية غير المصرح بها ما يلي: المسكرات من
              أي نوع ؛ العقاقير المحظورة أو غيرها من المنتجات غير القانونية ؛ المشروبات
              الكحولية؛ العاب الحظ؛ ومحتوى إباحي أو رسومي أو صور أو منتجات للبالغين
              الأخرى. قد تؤدي عمليات نشر أي منتجات أو محتوى غير مصرح به إلى الإنهاء الفوري
              لحسابك وحظر مدى الحياة من استخدام الموقع.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >نحن مزود خدمة ولا نقدم أي تعهدات فيما يتعلق بسلامة أو فعالية أو كفاية أو
              دقة أو توافر أو أسعار أو تقييمات أو مراجعات أو شرعية أي من المعلومات الواردة
              في الموقع أو عروض التجارة الإلكترونية المعروضة أو المتاحة من خلال الموقع.
              أنت تدرك وتوافق على أن محتوى الموقع لا يحتوي أو يشكل إقرارات يمكن الاعتماد
              عليها بشكل معقول ، وتوافق على حمايتنا من أي أخطاء أو سهو أو تحريفات واردة في
              محتوى الموقع. نحن لا نصادق أو نوصي بأي من عروض التجارة الإلكترونية ويتم
              توفير الموقع لأغراض إعلامية وإعلانية فقط.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.f14vvtastjey">
            <span class="c1">تسجيل المستخدم</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >قد يُطلب منك التسجيل في الموقع من أجل الوصول إلى عروض التجارة الإلكترونية.
              أنت توافق على الحفاظ على سرية كلمة المرور الخاصة بك وستكون مسؤولاً عن جميع
              استخدامات حسابك وكلمة المرور الخاصة بك. نحتفظ بالحق في إزالة أو استرداد أو
              تغيير اسم المستخدم الذي تحدده إذا قررنا ، وفقًا لتقديرنا الخاص ، أن اسم
              المستخدم هذا غير مناسب أو فاحش أو مرفوض بأي شكل آخر.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.xxfuvcn8a8pz">
            <span class="c1">عروض التجارة الإلكترونية</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >نحن نبذل قصارى جهدنا لعرض الألوان والميزات والمواصفات وتفاصيل عروض التجارة
              الإلكترونية المتوفرة على الموقع بأكبر قدر ممكن من الدقة. قد تكون بعض عروض
              التجارة الإلكترونية متاحة حصريًا عبر الإنترنت من خلال الموقع. قد يكون لعروض
              التجارة الإلكترونية هذه كميات محدودة وتخضع للإرجاع أو الاستبدال فقط وفقًا
              لسياسة الإرجاع الخاصة بنا.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >نحتفظ بالحق في تحديد كميات عروض التجارة الإلكترونية المعروضة أو المتاحة على
              الموقع. تخضع جميع الأوصاف أو الأسعار الخاصة بعروض التجارة الإلكترونية
              للتغيير في أي وقت دون إشعار ، وفقًا لتقديرنا الخاص. نحتفظ بالحق في إيقاف أي
              من عروض التجارة الإلكترونية في أي وقت ولأي سبب. نحن لا نضمن أن جودة أي من
              عروض التجارة الإلكترونية التي اشتريتها ستفي بتوقعاتك أو أنه سيتم تصحيح أي
              أخطاء في الموقع.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.fds1y8pkdv47">
            <span class="c1">المشتريات والدفع</span>
          </h2>
          <p class="c5" dir="rtl"><span class="c0">نقبل طرق الدفع التالية:</span></p>
          <ul class="c3 lst-kix_r8nour59axl-0 start">
            <li class="c9 li-bullet-0" dir="rtl"><span class="c0">تأشيرة</span></li>
            <li class="c9 li-bullet-0" dir="rtl">
              <span class="c0">بطاقة ماستر بطاقة ائتمان</span>
            </li>
            <li class="c9 li-bullet-0" dir="rtl">
              <span class="c0">أمريكان اكسبريس</span>
            </li>
            <li class="c9 li-bullet-0" dir="rtl">
              <span class="c0">الدفع بالتقسيط</span>
            </li>
          </ul>
          <p class="c5" dir="rtl">
            <span class="c0"
              >أنت توافق على تقديم معلومات الشراء والحساب الحالية والكاملة والدقيقة لجميع
              مشتريات عروض التجارة الإلكترونية التي تتم عبر الموقع. أنت توافق أيضًا على
              تحديث معلومات الحساب والدفع على الفور ، بما في ذلك عنوان البريد الإلكتروني
              وطريقة الدفع وتاريخ انتهاء صلاحية بطاقة الدفع ، حتى نتمكن من إكمال معاملاتك
              والاتصال بك حسب الحاجة. ستتم إضافة ضريبة المبيعات إلى سعر المشتريات على
              النحو الذي نراه مطلوبًا. يجوز لنا تغيير الأسعار في أي وقت.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >أنت توافق على دفع جميع الرسوم بالأسعار السارية وقتها لمشترياتك وأي رسوم شحن
              مطبقة ، وتفوضنا بتحصيل أي مبالغ من هذه المبالغ على مقدم خدمة الدفع الذي
              اخترته عند تقديم طلبك. نحتفظ بالحق في تصحيح أي أخطاء أو أخطاء في التسعير ،
              حتى لو كنا قد طلبنا بالفعل أو تلقينا الدفع.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >نحتفظ بالحق في رفض أي طلب يتم تقديمه عبر الموقع. يجوز لنا ، وفقًا لتقديرنا
              الخاص ، تقييد أو إلغاء الكميات المشتراة لكل شخص أو لكل أسرة أو لكل طلب. قد
              تشمل هذه القيود الطلبات المقدمة من قبل أو تحته نفس حساب العميل و / أو نفس
              طريقة الدفع و / أو الطلبات التي تستخدم نفس عنوان الفوترة أو الشحن. نحن نحتفظ
              بالحق في تقييد أو حظر الطلبات التي ، في حكمنا الوحيد ، يبدو أنها مقدمة من
              التجار أو البائعين أو الموزعين.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >يجب أن يكون أي سوق أو ميسر دفع يرغب في اتخاذ هذا المسار على دراية بالمخاطر
              المرتبطة:</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >يُعد MoR تصنيفًا متوافقًا مع معايير الصناعة ولا يتم التعرف عليه رسميًا من
              قبل المخططات. تحتفظ Visa و Mastercard بالحق في تحديد تصنيف التاجر.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >إذا تم وضع علامة عليها بواسطة مخططات البطاقة ، فسيكون عليهم الالتزام بتصحيح
              إعدادهم وقد يخضعون لعمليات تقييم عدم الامتثال.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.23gc3rrjpknv">
            <span class="c1">الأنشطة المحظورة</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >لا يجوز لك الوصول إلى الموقع أو استخدامه لأي غرض آخر غير ذلك الذي نوفر
              الموقع من أجله. لا يجوز استخدام الموقع فيما يتعلق بأي مساع تجارية باستثناء
              تلك التي تم اعتمادها أو الموافقة عليها بشكل خاص من قبلنا.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0">بصفتك مستخدمًا للموقع ، فإنك توافق على عدم:</span>
          </p>
          <ol class="c3 lst-kix_77qrkei9b7ez-0 start" start="1">
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >استرداد البيانات أو المحتوى الآخر بشكل منهجي من الموقع لإنشاء أو تجميع ،
                بشكل مباشر أو غير مباشر ، مجموعة أو تجميع أو قاعدة بيانات أو دليل دون إذن
                كتابي منا.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >قم بأي استخدام غير مصرح به لعروض التجارة الإلكترونية ، بما في ذلك جمع
                أسماء المستخدمين و / أو عناوين البريد الإلكتروني للمستخدمين عن طريق
                الوسائل الإلكترونية أو غيرها من الوسائل بغرض إرسال بريد إلكتروني غير مرغوب
                فيه ، أو إنشاء حسابات مستخدمين بوسائل آلية أو تحت ذرائع كاذبة.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >استخدم وكيل شراء أو وكيل شراء لإجراء عمليات شراء على الموقع.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >التحايل على ميزات الموقع المتعلقة بالأمان أو تعطيلها أو التدخل فيها ، بما
                في ذلك الميزات التي تمنع أو تقيد استخدام أو نسخ أي محتوى أو تفرض قيودًا
                على استخدام الموقع و / أو المحتوى المتضمن فيه.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0">الانخراط في تأطير أو ربط غير مصرح به للموقع.</span>
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >خداع أو خداع أو تضليلنا نحن والمستخدمين الآخرين ، خاصة في أي محاولة
                لمعرفة معلومات الحساب الحساسة مثل كلمات مرور المستخدم.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >استخدم خدمات الدعم الخاصة بنا بشكل غير لائق أو أرسل تقارير كاذبة عن إساءة
                المعاملة أو سوء السلوك.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >الانخراط في أي استخدام آلي للنظام ، مثل استخدام البرامج النصية لإرسال
                التعليقات أو الرسائل ، أو استخدام أي استخراج للبيانات ، أو الروبوتات ، أو
                أدوات مماثلة لجمع البيانات واستخراجها.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >التدخل في أو تعطيل أو إنشاء عبء لا داعي له على الموقع أو الشبكات أو
                الخدمات المتصلة بالموقع.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >محاولة انتحال شخصية مستخدم أو شخص آخر أو استخدام اسم مستخدم لمستخدم
                آخر.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0">بيع أو نقل ملف التعريف الخاص بك.</span>
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >استخدم أي معلومات تم الحصول عليها من الموقع من أجل مضايقة أو الإساءة أو
                الإضرار بشخص آخر.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >استخدم عروض التجارة الإلكترونية كجزء من أي جهد للتنافس معنا أو استخدام
                الموقع و / أو المحتوى لأي مسعى مدر للدخل أو مؤسسة تجارية.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >فك أو فك أو فك أو عكس هندسة أي من البرامج التي تتألف منها أو تشكل بأي شكل
                من الأشكال جزءًا من الموقع.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >محاولة تجاوز أي إجراءات للموقع مصممة لمنع أو تقييد الوصول إلى الموقع ، أو
                أي جزء من الموقع.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >مضايقة أو مضايقة أو تخويف أو تهديد أي من موظفينا أو وكلائنا المشاركين في
                تقديم أي جزء من عروض التجارة الإلكترونية لك.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >حذف حقوق الطبع والنشر أو إشعار حقوق الملكية الأخرى من أي محتوى.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >نسخ أو تعديل برنامج الموقع ، بما في ذلك على سبيل المثال لا الحصر Flash أو
                PHP أو HTML أو JavaScript أو أي كود آخر.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >تحميل أو نقل (أو محاولة تحميل أو نقل) فيروسات أو أحصنة طروادة أو مواد
                أخرى ، بما في ذلك الاستخدام المفرط للأحرف الكبيرة والبريد العشوائي (النشر
                المستمر للنص المتكرر) ، والتي تتعارض مع استخدام أي طرف واستمتاعه بالموقع
                أو يعدل أو يضعف أو يعطل أو يغير أو يتدخل في استخدام أو ميزات أو وظائف أو
                تشغيل أو صيانة عروض التجارة الإلكترونية.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >تحميل أو نقل (أو محاولة تحميل أو نقل) أي مادة تعمل كآلية لجمع أو نقل
                المعلومات السلبية أو النشطة ، بما في ذلك على سبيل المثال لا الحصر ،
                تنسيقات تبادل الرسومات الواضحة ("gifs") ، 1 × 1 بكسل ، أخطاء الويب ، ملفات
                تعريف الارتباط ، أو أجهزة أخرى مماثلة (يشار إليها أحيانًا باسم "برامج
                التجسس" أو "آليات التجميع السلبي" أو "pcms").</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >باستثناء ما قد يكون نتيجة استخدام محرك البحث القياسي أو مستعرض الإنترنت
                أو استخدام أو تشغيل أو تطوير أو توزيع أي نظام آلي ، بما في ذلك على سبيل
                المثال لا الحصر ، أي عنكبوت أو روبوت أو أداة غش أو مكشطة أو قارئ غير متصل
                بالإنترنت يصل إلى الموقع ، أو استخدام أو تشغيل أي برنامج نصي أو برنامج آخر
                غير مصرح به.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >الاستخفاف أو التشويه أو الإضرار بطريقة أخرى ، في رأينا ، نحن و / أو
                الموقع.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >استخدام الموقع بطريقة تتعارض مع أي قوانين أو لوائح معمول بها.</span
              >
            </li>
          </ol>
          <h2 class="c6" dir="rtl" id="h.ncdiji63l83y">
            <span class="c1">المساهمات التي يولدها المستخدم</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >قد يدعوك الموقع للدردشة أو المساهمة في أو المشاركة في المدونات ولوحات
              الرسائل والمنتديات عبر الإنترنت وغيرها من الوظائف ، وقد يوفر لك الفرصة
              لإنشاء وتقديم ونشر وعرض ونقل وأداء ونشر وتوزيع ، أو بث المحتوى والمواد إلينا
              أو على الموقع ، بما في ذلك على سبيل المثال لا الحصر النصوص أو الكتابات أو
              الفيديو أو الصوت أو الصور الفوتوغرافية أو الرسومات أو التعليقات أو
              الاقتراحات أو المعلومات الشخصية أو المواد الأخرى (يشار إليها مجتمعة باسم
              "المساهمات"). قد تكون المساهمات قابلة للعرض من قبل المستخدمين الآخرين للموقع
              وعروض التجارة الإلكترونية ومن خلال مواقع الويب الخاصة بالأطراف الثالثة. على
              هذا النحو ، قد يتم التعامل مع أي مساهمات ترسلها على أنها غير سرية وغير
              مملوكة. عندما تنشئ أي مساهمات أو تتيحها ، فإنك بذلك تقر وتضمن ما يلي:</span
            >
          </p>
          <ol class="c3 lst-kix_453j2ub8pw4w-0 start" start="1">
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >إن إنشاء مساهماتك أو توزيعها أو نقلها أو عرضها العام أو أدائها والوصول
                إليها أو تنزيلها أو نسخها لا ينتهك ولن ينتهك حقوق الملكية ، بما في ذلك على
                سبيل المثال لا الحصر حقوق الطبع والنشر أو براءات الاختراع أو العلامة
                التجارية أو الأسرار التجارية أو الحقوق المعنوية لأي طرف ثالث.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >أنت منشئ ومالك أو لديك التراخيص والحقوق والموافقات والإصدارات والأذونات
                اللازمة للاستخدام وتفويضنا نحن والموقع والمستخدمين الآخرين للموقع لاستخدام
                مساهماتك بأي طريقة يتوخاها الموقع وهذه شروط الاستخدام.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >لديك موافقة كتابية و / أو تصريح و / أو إذن من كل فرد يمكن التعرف عليه في
                مساهماتك لاستخدام اسم أو شكل كل فرد يمكن التعرف عليه لتمكين إدراج واستخدام
                مساهماتك بأي طريقة تتوخاها الموقع وشروط الاستخدام هذه.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0">مساهماتك ليست خاطئة أو غير دقيقة أو مضللة.</span>
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >مساهماتك ليست إعلانات غير مرغوب فيها أو غير مصرح بها ، أو مواد ترويجية ،
                أو مخططات هرمية ، أو رسائل متسلسلة ، أو بريد عشوائي ، أو رسائل بريدية
                جماعية ، أو أشكال أخرى من الالتماس.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >مساهماتك ليست فاحشة ، بذيئة ، فاسقة ، قذرة ، عنيفة ، مضايقة ، تشهيرية ،
                افترائية ، أو مرفوضة بأي شكل آخر (على النحو الذي نحدده).</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >مساهماتك لا تسخر أو تسخر أو تحط من قدر أو تخيف أو تسيء إلى أي شخص.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >لا تدعو مساهماتك إلى الإطاحة العنيفة بأية حكومة أو تحرض أو تشجع أو تهدد
                بإيذاء جسدي آخر.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >لا تنتهك مساهماتك أي قانون أو لائحة أو قاعدة معمول بها.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >لا تنتهك مساهماتك الخصوصية أو حقوق الدعاية لأي طرف ثالث.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >لا تحتوي مساهماتك على أي مواد تطلب معلومات شخصية من أي شخص يقل عمره عن 18
                عامًا أو تستغل الأشخاص الذين تقل أعمارهم عن 18 عامًا بطريقة جنسية أو
                عنيفة.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >لا تنتهك مساهماتك أي قانون معمول به يتعلق باستغلال الأطفال في المواد
                الإباحية ، أو يقصد بها حماية صحة أو رفاهية القاصرين.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >لا تتضمن مساهماتك أي تعليقات مسيئة مرتبطة بالعرق أو الأصل القومي أو الجنس
                أو التفضيل الجنسي أو الإعاقة الجسدية.</span
              >
            </li>
            <li class="c4 li-bullet-0" dir="rtl">
              <span class="c0"
                >لا تنتهك مساهماتك أو ترتبط بمواد تنتهك أي شرط من شروط الاستخدام هذه أو أي
                قانون أو لائحة معمول بها.</span
              >
            </li>
          </ol>
          <p class="c5" dir="rtl">
            <span class="c0"
              >أي استخدام للموقع أو عروض التجارة الإلكترونية بما ينتهك ما سبق ينتهك شروط
              الاستخدام هذه وقد يؤدي ، من بين أمور أخرى ، إلى إنهاء أو تعليق حقوقك في
              استخدام الموقع وعروض التجارة الإلكترونية.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.e26k7r8r4oyq">
            <span class="c1">رخصة المساهمة</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >من خلال نشر مساهماتك على أي جزء من الموقع أو إتاحة الوصول إلى المساهمات إلى
              الموقع عن طريق ربط حسابك من الموقع بأي من حسابات الشبكات الاجتماعية الخاصة
              بك ، فإنك تمنح تلقائيًا وتقر وتضمن أن لديك الحق في منح ، لنا حق غير مقيد
              وغير محدود وغير قابل للإلغاء ودائم وغير حصري وقابل للتحويل وخالي من حقوق
              الملكية ومدفوع بالكامل في جميع أنحاء العالم وترخيص لاستضافة واستخدام ونسخ
              وإعادة إنتاج وكشف وبيع وإعادة بيع ونشر وبث وإعادة ترجمة ، أرشفة وتخزين
              وذاكرة تخزين مؤقت وأداء علني وعرض علني وإعادة تنسيق وترجمة ونقل ومقتطفات
              (كليًا أو جزئيًا) وتوزيع هذه المساهمات (بما في ذلك ، على سبيل المثال لا
              الحصر ، صورتك وصوتك) لأي غرض ، تجاري ، إعلاني ، أو غير ذلك ، وإعداد أعمال
              مشتقة من هذه المساهمات ، أو دمجها في أعمال أخرى ، ومنح التراخيص الفرعية
              المذكورة أعلاه والتصريح بها. قد يتم الاستخدام والتوزيع بأي تنسيقات وسائط
              وعبر أي قنوات وسائط.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >سينطبق هذا الترخيص على أي شكل أو وسائط أو تقنية معروفة الآن أو مطورة فيما
              بعد ، ويتضمن استخدامنا لاسمك واسم الشركة واسم الامتياز ، حسب الاقتضاء ، وأي
              من العلامات التجارية وعلامات الخدمة والأسماء التجارية والشعارات ، والصور
              الشخصية والتجارية التي تقدمها. أنت تتنازل عن جميع الحقوق المعنوية في
              مساهماتك ، وتضمن أن الحقوق المعنوية لم يتم التأكيد عليها بطريقة أخرى في
              مساهماتك.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >نحن لا نؤكد أي ملكية على مساهماتك. تحتفظ بالملكية الكاملة لجميع مساهماتك
              وأي حقوق ملكية فكرية أو حقوق ملكية أخرى مرتبطة بمساهماتك. نحن لسنا مسؤولين
              عن أي بيانات أو إقرارات في مساهماتك التي قدمتها في أي منطقة على الموقع. أنت
              وحدك المسؤول عن مساهماتك في الموقع وتوافق صراحة على إعفائنا من أي وكل
              مسؤولية والامتناع عن أي إجراء قانوني ضدنا فيما يتعلق بمساهماتك.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >لدينا الحق ، وفقًا لتقديرنا الخاص والمطلق ، (1) في تعديل أو تنقيح أو تغيير
              أي مساهمات ؛ (2) لإعادة تصنيف أي مساهمات لوضعها في مواقع أكثر ملاءمة على
              الموقع ؛ و (3) للفرز المسبق أو حذف أي مساهمات في أي وقت ولأي سبب ، دون سابق
              إنذار. ليس لدينا أي التزام بمراقبة مساهماتك.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.13kn7ktll4xy">
            <span class="c1">إرشادات للمراجعات</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >قد نوفر لك مناطق على الموقع لترك التعليقات أو التقييمات. عند نشر مراجعة ،
              يجب أن تمتثل للمعايير التالية: (1) يجب أن تكون لديك خبرة مباشرة مع الشخص /
              الكيان قيد المراجعة ؛ (2) يجب ألا تحتوي تعليقاتك على ألفاظ مسيئة أو لغة
              مسيئة أو عنصرية أو مسيئة أو تحض على الكراهية ؛ (3) يجب ألا تحتوي مراجعاتك
              على مراجع تمييزية على أساس الدين أو العرق أو الجنس أو الأصل القومي أو العمر
              أو الحالة الاجتماعية أو التوجه الجنسي أو الإعاقة ؛ (4) يجب ألا تحتوي
              مراجعاتك على إشارات إلى نشاط غير قانوني ؛ (5) يجب ألا تكون تابعًا لمنافسين
              إذا نشرت مراجعات سلبية ؛ (6) يجب ألا تتوصل إلى أي استنتاجات بشأن شرعية
              السلوك ؛ (7) لا يجوز لك نشر أي بيانات خاطئة أو مضللة ؛ و (8) لا يجوز لك
              تنظيم حملة لتشجيع الآخرين على نشر المراجعات سواء كانت إيجابية أو
              سلبية.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >يجوز لنا قبول المراجعات أو رفضها أو إزالتها وفقًا لتقديرنا الخاص. ليس لدينا
              أي التزام على الإطلاق بفحص المراجعات أو حذفها ، حتى لو اعتبر أي شخص أن
              التعليقات مرفوضة أو غير دقيقة. لا يتم اعتماد المراجعات من قبلنا ، ولا تمثل
              بالضرورة آراءنا أو وجهات نظر أي من الشركات التابعة لنا أو شركائنا. نحن لا
              نتحمل أي مسؤولية عن أي مراجعة أو عن أي مطالبات أو التزامات أو خسائر ناتجة عن
              أي مراجعة. من خلال نشر مراجعة ، فإنك تمنحنا بموجب هذا حقًا وترخيصًا دائمًا ،
              وغير حصري ، وعالمي ، وخالي من حقوق الملكية ، ومدفوع بالكامل ، وقابل للتنازل
              ، وقابل للترخيص من الباطن لإعادة إنتاج ، وتعديل ، وترجمة ، ونقل بأي وسيلة ،
              وعرض ، وأداء ، و / أو توزيع كل المحتوى المتعلق بالمراجعات.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.gaud8an0i9pf">
            <span class="c1">ترخيص تطبيقات الهاتف المتحرك</span>
          </h2>
          <h3 class="c16" dir="rtl" id="h.2a2qsdwkncah">
            <span class="c14 c21">ترخيص الاستخدام</span>
          </h3>
          <p class="c5" dir="rtl">
            <span class="c0"
              >إذا قمت بالوصول إلى عروض التجارة الإلكترونية عبر تطبيق الهاتف المحمول ،
              فإننا نمنحك حقًا محدودًا وقابل للإلغاء وغير حصري وغير قابل للتحويل لتثبيت
              تطبيق الهاتف المحمول واستخدامه على الأجهزة الإلكترونية اللاسلكية التي
              تمتلكها أو تتحكم فيها ، وكذلك حق الوصول والاستخدام تطبيق الهاتف المحمول على
              هذه الأجهزة يتوافق تمامًا مع شروط وأحكام ترخيص تطبيق الهاتف المحمول هذا
              الوارد في شروط الاستخدام هذه. لا يجوز لك: (1) إلغاء التحويل البرمجي أو
              الهندسة العكسية أو التفكيك أو محاولة اشتقاق الكود المصدري للتطبيق أو فك
              تشفيره ؛ (2) إجراء أي تعديل أو تكييف أو تحسين أو تحسين أو ترجمة أو عمل مشتق
              من التطبيق ؛ (3) تنتهك أي قوانين أو قواعد أو لوائح معمول بها فيما يتعلق
              بوصولك إلى التطبيق أو استخدامه ؛ (4) إزالة أو تغيير أو حجب أي إشعار ملكية
              (بما في ذلك أي إشعار بحقوق النشر أو العلامة التجارية) نشره نحن أو المرخصون
              للتطبيق ؛ (5) استخدام التطبيق لأي مسعى مدر للدخل أو مشروع تجاري أو أي غرض
              آخر لم يتم تصميمه أو الغرض منه ؛ (6) إتاحة التطبيق عبر شبكة أو بيئة أخرى
              تسمح بالوصول أو الاستخدام من قبل أجهزة متعددة أو مستخدمين في نفس الوقت ؛ (7)
              استخدام التطبيق لإنشاء منتج أو خدمة أو برنامج منافس بشكل مباشر أو غير مباشر
              للتطبيق أو بديلاً عنه بأي شكل من الأشكال ؛ (8) استخدام التطبيق لإرسال
              استفسارات آلية إلى أي موقع ويب أو لإرسال أي بريد إلكتروني تجاري غير مرغوب
              فيه ؛ أو (9) استخدام أي معلومات ملكية أو أي من واجهاتنا أو ملكيتنا الفكرية
              الأخرى في تصميم أو تطوير أو تصنيع أو ترخيص أو توزيع أي تطبيقات أو ملحقات أو
              أجهزة للاستخدام مع التطبيق.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.60k6j0937von">
            <span class="c1">أجهزة آبل وأندرويد</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >تنطبق الشروط التالية عندما تستخدم تطبيقًا للهاتف المحمول تم الحصول عليه من
              متجر Apple أو Google Play (يُشار إلى كل منهما باسم "موزع تطبيقات") للوصول
              إلى عروض التجارة الإلكترونية: (1) يقتصر الترخيص الممنوح لك لتطبيق الهاتف
              المحمول الخاص بنا على غير - ترخيص قابل للنقل لاستخدام التطبيق على جهاز
              يستخدم أنظمة تشغيل Apple iOS أو Android ، حسب الاقتضاء ، ووفقًا لقواعد
              الاستخدام المنصوص عليها في شروط خدمة موزع التطبيقات المعمول بها ؛ (2) نحن
              مسؤولون عن تقديم أي خدمات صيانة ودعم فيما يتعلق بتطبيق الهاتف المحمول كما هو
              محدد في شروط وأحكام ترخيص تطبيق الهاتف المحمول هذا الوارد في شروط الاستخدام
              هذه أو كما هو مطلوب بموجب القانون المعمول به ، وأنت تقر بأن كل لا يلتزم موزع
              التطبيقات على الإطلاق بتقديم أي خدمات صيانة ودعم فيما يتعلق بتطبيق الهاتف
              المحمول ؛ (3) في حالة فشل تطبيق الهاتف المحمول في الامتثال لأي ضمان معمول به
              ، يجوز لك إخطار موزع التطبيقات المعمول به ، ويجوز لموزع التطبيقات ، وفقًا
              لشروطه وسياساته ، إعادة سعر الشراء ، إن وجد ، مدفوعة مقابل تطبيق الهاتف
              المحمول ، وإلى أقصى حد يسمح به القانون المعمول به ، لن يكون لدى موزع
              التطبيقات أي التزام ضمان آخر على الإطلاق فيما يتعلق بتطبيق الهاتف المحمول ؛
              (4) تقر وتتعهد (1) أنك لست مقيمًا في بلد خاضع لحظر تفرضه الحكومة الأمريكية ،
              أو تم تحديده من قبل حكومة الولايات المتحدة كدولة "داعمة للإرهاب" و (2) أنك
              لست كذلك مدرجة في أي قائمة حكومية أمريكية للأطراف المحظورة أو المقيدة ؛ (5)
              يجب عليك الامتثال لشروط اتفاقية الطرف الثالث السارية عند استخدام تطبيق
              الهاتف المحمول ، على سبيل المثال ، إذا كان لديك تطبيق VoIP ، فيجب ألا تنتهك
              اتفاقية خدمة البيانات اللاسلكية الخاصة بهم عند استخدام تطبيق الهاتف المحمول
              ؛ و (6) تقر وتوافق على أن موزعي التطبيقات هم طرف ثالث مستفيد من البنود
              والشروط الواردة في ترخيص تطبيق الهاتف المحمول هذا الوارد في شروط الاستخدام
              هذه ، وأن كل موزع تطبيقات سيكون له الحق (وسيعتبر أنه يمتلك قبلت بالحق) لفرض
              الشروط والأحكام الواردة في ترخيص تطبيق الهاتف المحمول هذا الوارد في شروط
              الاستخدام هذه ضدك بصفتك طرفًا ثالثًا مستفيدًا منها.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.3sm6y419e6ev">
            <span class="c1">وسائل الاعلام الاجتماعية</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >كجزء من وظائف الموقع ، يمكنك ربط حسابك بحساباتك عبر الإنترنت مع مزودي خدمة
              تابعين لجهات خارجية (كل حساب من هذا القبيل ، "حساب طرف ثالث") إما عن طريق:
              (1) توفير حساب الطرف الثالث الخاص بك معلومات تسجيل الدخول من خلال الموقع ؛
              أو (2) السماح لنا بالوصول إلى حساب الطرف الثالث الخاص بك ، كما هو مسموح به
              بموجب الشروط والأحكام السارية التي تحكم استخدامك لكل حساب طرف ثالث. أنت تقر
              وتضمن أنه يحق لك الكشف عن معلومات تسجيل الدخول إلى حساب الطرف الثالث الخاص
              بك إلينا و / أو منحنا حق الوصول إلى حساب الطرف الثالث الخاص بك ، دون خرقك
              لأي من الشروط والأحكام التي تحكم استخدامك لما هو معمول به. حساب الطرف الثالث
              ، وبدون إلزامنا بدفع أي رسوم أو جعلنا خاضعين لأي قيود استخدام يفرضها موفر
              خدمة الطرف الثالث لحساب الطرف الثالث. بمنحنا حق الوصول إلى أي حسابات تابعة
              لجهات خارجية ، فأنت تدرك أنه (1) يجوز لنا الوصول إلى أي محتوى قمت بتوفيره
              وتخزينه في حساب الطرف الثالث الخاص بك ("الشبكة الاجتماعية) (إن أمكن) ،
              وتوفيره وتخزينه (إن أمكن) المحتوى ") حتى يكون متاحًا على الموقع وعبره عبر
              حسابك ، بما في ذلك على سبيل المثال لا الحصر ، أي قوائم أصدقاء و (2) يجوز لنا
              إرسال معلومات إضافية إلى حساب الطرف الثالث الخاص بك واستلامها منه إلى الحد
              الذي يتم إخطارك به عند الارتباط حسابك مع حساب الطرف الثالث. اعتمادًا على
              حسابات الجهات الخارجية التي تختارها وتخضع لإعدادات الخصوصية التي قمت
              بتعيينها في حسابات الأطراف الثالثة ، قد تكون معلومات التعريف الشخصية التي
              تنشرها على حسابات الأطراف الثالثة الخاصة بك متاحة على حسابك ومن خلاله على
              الموقع. يرجى ملاحظة أنه في حالة عدم توفر حساب جهة خارجية أو خدمة مرتبطة به
              أو تم إنهاء وصولنا إلى حساب الطرف الثالث هذا من قبل مزود خدمة الطرف الثالث ،
              فقد لا يكون محتوى الشبكة الاجتماعية متاحًا على الموقع وعبره. سيكون لديك
              القدرة على تعطيل الاتصال بين حسابك على الموقع وحسابات الطرف الثالث الخاصة بك
              في أي وقت. يرجى ملاحظة أن علاقتك بمقدمي خدمات الطرف الثالث المرتبطين بحسابات
              الطرف الثالث الخاصة بك تحكمها فقط الاتفاقية (الاتفاقيات) الخاصة بك مع مقدمي
              الخدمات من هذا الطرف الثالث. نحن لا نبذل أي جهد لمراجعة أي محتوى على الشبكة
              الاجتماعية لأي غرض ، بما في ذلك على سبيل المثال لا الحصر ، الدقة أو الشرعية
              أو عدم الانتهاك ، ونحن لسنا مسؤولين عن أي محتوى على الشبكة الاجتماعية. أنت
              تقر وتوافق على أنه يجوز لنا الوصول إلى دفتر عناوين بريدك الإلكتروني المرتبط
              بحساب طرف ثالث وقائمة جهات الاتصال الخاصة بك المخزنة على جهازك المحمول أو
              الكمبيوتر اللوحي الخاص بك فقط لأغراض تحديد وإبلاغك بجهات الاتصال التي سجلت
              أيضًا لاستخدام الموقع . يمكنك إلغاء تنشيط الاتصال بين الموقع وحساب الطرف
              الثالث الخاص بك عن طريق الاتصال بنا باستخدام معلومات الاتصال أدناه أو من
              خلال إعدادات حسابك (إن أمكن). سنحاول حذف أي معلومات مخزنة على خوادمنا تم
              الحصول عليها من خلال حساب الطرف الثالث هذا ، باستثناء اسم المستخدم وصورة
              الملف الشخصي التي أصبحت مرتبطة بحسابك.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.8k7ugi3f6glm">
            <span class="c1">التقديمات</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >أنت تقر وتوافق على أن أي أسئلة أو تعليقات أو اقتراحات أو أفكار أو ملاحظات
              أو معلومات أخرى تتعلق بالموقع أو عروض التجارة الإلكترونية ("عمليات الإرسال")
              التي تقدمها لنا غير سرية وستصبح ملكنا الوحيد. سنمتلك الحقوق الحصرية ، بما في
              ذلك جميع حقوق الملكية الفكرية ، ويحق لنا استخدام ونشر هذه المواد المقدمة لأي
              غرض قانوني ، تجاري أو غير ذلك ، دون إقرار أو تعويض لك. أنت تتنازل بموجب هذا
              عن جميع الحقوق المعنوية لأي من هذه التقديمات ، وتتعهد بموجب هذا بأن أي من
              هذه التقديمات أصلية معك أو أن لديك الحق في إرسال مثل هذه التقديمات. أنت
              توافق على أنه لن يكون هناك أي طعن ضدنا بسبب أي انتهاك مزعوم أو فعلي أو
              اختلاس لأي حق ملكية في عمليات الإرسال الخاصة بك.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.a4pho1jpqa9o">
            <span class="c1">إدارة الموقع</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >نحن نحتفظ بالحق ، ولكن ليس الالتزام ، في: (1) مراقبة الموقع بحثًا عن
              انتهاكات شروط الاستخدام هذه ؛ (2) اتخاذ الإجراءات القانونية المناسبة ضد أي
              شخص ، وفقًا لتقديرنا الخاص ، ينتهك القانون أو شروط الاستخدام هذه ، بما في
              ذلك على سبيل المثال لا الحصر ، إبلاغ سلطات إنفاذ القانون بهذا المستخدم ؛ (3)
              وفقًا لتقديرنا الخاص وعلى سبيل المثال لا الحصر ، رفض أو تقييد الوصول أو
              تقييد توفر أو تعطيل (إلى الحد الممكن تقنيًا) أي من مساهماتك أو أي جزء منها ؛
              (4) وفقًا لتقديرنا المطلق ودون قيود أو إشعار أو مسؤولية ، لإزالة من الموقع
              أو تعطيل جميع الملفات والمحتويات الزائدة في الحجم أو التي تشكل عبئًا بأي شكل
              من الأشكال على أنظمتنا ؛ و (5) إدارة الموقع بطريقة أخرى بطريقة مصممة لحماية
              حقوقنا وممتلكاتنا وتسهيل التشغيل السليم للموقع وعروض التجارة
              الإلكترونية.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.r1mkewjz9mk9">
            <span class="c1">سياسة الخصوصية</span>
          </h2>
          <p class="c5" dir="rtl">
            <span
              >نحن نهتم بخصوصية البيانات وأمانها. يرجى مراجعة سياسة الخصوصية الخاصة
              بنا:</span
            ><span class="c15"
              ><a
                class="c11"
                href="https://www.google.com/url?q=https://www.popsy.app/privacy-policy?lang%3Den&amp;sa=D&amp;source=editors&amp;ust=1680259268385625&amp;usg=AOvVaw2S2azRv5h-YhNDiCXUbmpa"
                >https://www.popsy.app/privacy-policy؟lang=ar</a
              ></span
            ><span class="c0"
              >. باستخدام الموقع أو عروض التجارة الإلكترونية ، فإنك توافق على الالتزام
              بسياسة الخصوصية الخاصة بنا ، والتي تم دمجها في شروط الاستخدام هذه. يرجى
              العلم بأن الموقع وعروض التجارة الإلكترونية مستضافة في دولة الإمارات العربية
              المتحدة. إذا قمت بالوصول إلى الموقع أو عروض التجارة الإلكترونية من أي منطقة
              أخرى من العالم بقوانين أو متطلبات أخرى تحكم جمع البيانات الشخصية أو
              استخدامها أو الكشف عنها والتي تختلف عن القوانين المعمول بها في دولة الإمارات
              العربية المتحدة ، فمن خلال استمرار استخدامك للموقع ، أنت تنقل بياناتك إلى
              الإمارات العربية المتحدة ، وتوافق على نقل بياناتك إلى الإمارات العربية
              المتحدة ومعالجتها فيها.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.9s8gjtcuyw4q">
            <span class="c1">انتهاكات حقوق الطبع والنشر</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >نحن نحترم حقوق الملكية الفكرية للآخرين. إذا كنت تعتقد أن أي مادة متوفرة على
              الموقع أو من خلاله تنتهك أي حقوق نشر تمتلكها أو تتحكم فيها ، فيرجى إخطارنا
              على الفور باستخدام معلومات الاتصال الواردة أدناه ("الإخطار"). سيتم إرسال
              نسخة من إشعارك إلى الشخص الذي قام بنشر أو تخزين المواد المعنونة في الإخطار.
              يرجى العلم أنه وفقًا للقانون المعمول به ، قد تكون مسؤولاً عن الأضرار إذا
              قدمت تحريفات جوهرية في الإخطار. وبالتالي ، إذا لم تكن متأكدًا من أن المواد
              الموجودة على الموقع أو المرتبطة به تنتهك حقوق الطبع والنشر الخاصة بك ، فيجب
              أن تفكر أولاً في الاتصال بمحامٍ.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.jw1zk8tl60me">
            <span class="c1">المدة والإنهاء</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >تظل شروط الاستخدام هذه سارية المفعول والتأثير الكامل أثناء استخدامك للموقع.
              بدون تحديد أي شرط آخر لشروط الاستخدام هذه ، نحتفظ بالحق في رفض الوصول إلى
              واستخدام الموقع وعروض التجارة الإلكترونية (بما في ذلك بعض القيود المفروضة
              على IP ، وفقًا لتقديرنا الخاص ودون إشعار أو مسؤولية) لأي سبب أو بدون سبب ،
              بما في ذلك على سبيل المثال لا الحصر انتهاك أي تمثيل أو ضمان أو تعهد وارد في
              شروط الاستخدام هذه أو أي قانون أو لائحة معمول بها. يجوز لنا إنهاء استخدامك
              أو مشاركتك في الموقع وعروض التجارة الإلكترونية أو حذف حسابك وأي محتوى أو
              معلومات نشرتها في أي وقت ، دون سابق إنذار ، وفقًا لتقديرنا الخاص.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >إذا قمنا بإنهاء حسابك أو تعليقه لأي سبب ، فيُحظر عليك التسجيل وإنشاء حساب
              جديد باسمك أو اسم مزيف أو مستعار أو اسم أي طرف ثالث ، حتى لو كنت تتصرف نيابة
              عن الطرف الثالث حزب. بالإضافة إلى إنهاء حسابك أو تعليقه ، فإننا نحتفظ بالحق
              في اتخاذ الإجراءات القانونية المناسبة ، بما في ذلك على سبيل المثال لا الحصر
              ، السعي للحصول على تعويضات مدنية وجنائية وزجرية.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.9t7b9dcvayy6">
            <span class="c1">التعديلات والانقطاعات</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >نحتفظ بالحق في تغيير أو تعديل أو إزالة محتويات الموقع في أي وقت أو لأي سبب
              وفقًا لتقديرنا الخاص دون إشعار. ومع ذلك ، فإننا لسنا ملزمين بتحديث أي
              معلومات على موقعنا. نحتفظ أيضًا بالحق في تعديل أو إيقاف كل أو جزء من عروض
              التجارة الإلكترونية دون إشعار في أي وقت. لن نكون مسؤولين تجاهك أو تجاه أي
              طرف ثالث عن أي تعديل أو تغيير في الأسعار أو تعليق أو وقف للموقع أو عروض
              التجارة الإلكترونية.</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0"
              >لا يمكننا ضمان الموقع وستتوفر عروض التجارة الإلكترونية في جميع الأوقات. قد
              نواجه مشاكل في الأجهزة أو البرامج أو غيرها من المشاكل أو نحتاج إلى إجراء
              صيانة متعلقة بالموقع ، مما يؤدي إلى انقطاعات أو تأخيرات أو أخطاء. نحتفظ
              بالحق في تغيير أو مراجعة أو تحديث أو تعليق أو إيقاف أو تعديل الموقع أو عروض
              التجارة الإلكترونية في أي وقت أو لأي سبب دون إخطارك. أنت توافق على أننا لا
              نتحمل أي مسؤولية من أي نوع عن أي خسارة أو ضرر أو إزعاج ناتج عن عدم قدرتك على
              الوصول إلى أو استخدام الموقع أو عروض التجارة الإلكترونية أثناء أي توقف أو
              توقف للموقع أو عروض التجارة الإلكترونية. لن يتم تفسير أي شيء في شروط
              الاستخدام هذه على أنه يلزمنا بالحفاظ على الموقع أو عروض التجارة الإلكترونية
              ودعمها أو توفير أي تصحيحات أو تحديثات أو إصدارات فيما يتعلق بذلك.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.jngzeyas87cu">
            <span class="c1">القانون الذي يحكم</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >تخضع هذه الشروط ويتم تحديدها وفقًا لقوانين دولة الإمارات العربية المتحدة.
              توافق Popsy LLC ونفسك بشكل نهائي على أن يكون لمحاكم الإمارات العربية المتحدة
              الاختصاص الحصري لحل أي نزاع قد ينشأ فيما يتعلق بهذه الشروط.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.1toids4epfcv">
            <span class="c1">حل النزاع</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >أنت توافق على تقديم جميع النزاعات المتعلقة بالشروط أو العلاقة التي أنشأتها
              هذه الاتفاقية إلى الاختصاص القضائي لمحاكم الإمارات العربية المتحدة بشكل
              نهائي. تحتفظ Popsy LLC أيضًا بالحق في رفع الدعاوى فيما يتعلق بجوهر الأمر في
              محاكم البلد الذي تقيم فيه أو ، إذا تم إدخال هذه الشروط في سياق تجارتك أو
              مهنتك ، في حالة مكانك الرئيسي عمل.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.tc2vq46mulac">
            <span class="c1">التصحيحات</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >قد تكون هناك معلومات على الموقع تحتوي على أخطاء مطبعية أو عدم دقة أو سهو قد
              يتعلق بعروض التجارة الإلكترونية ، بما في ذلك الأوصاف والأسعار والتوافر
              ومختلف المعلومات الأخرى. نحتفظ بالحق في تصحيح أي أخطاء أو عدم دقة أو سهو
              وتغيير أو تحديث المعلومات الموجودة على الموقع في أي وقت دون إشعار
              مسبق.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.r5pjhei3p9lb"><span class="c1">تنصل</span></h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >يتم تقديم عروض الموقع والتجارة الإلكترونية على حالته وبحسب توفره. أنت توافق
              على أن استخدامك للموقع وخدماتنا سيكون على مسؤوليتك وحدك. إلى أقصى حد يسمح به
              القانون ، فإننا نخلي مسؤوليتنا عن جميع الضمانات ، الصريحة أو الضمنية ، فيما
              يتعلق بالموقع وعروض التجارة الإلكترونية واستخدامك لهما ، بما في ذلك ، على
              سبيل المثال لا الحصر ، الضمانات الضمنية والضمانات المتعلقة بالبيع - النفخ.
              لا نقدم أي ضمانات أو إقرارات بشأن دقة أو اكتمال محتوى الموقع أو محتوى أي من
              مواقع الويب المرتبطة بالموقع ولن نتحمل أي مسؤولية أو مسؤولية عن أي (1) أخطاء
              أو أخطاء أو معلومات 2) إصابة شخصية أو ضرر بالممتلكات ، من أي نوع كان ، والذي
              ينتج عن وصولك إلى الموقع واستخدامه ، (3) أي وصول غير مصرح به إلى أو استخدام
              خوادمنا الآمنة و / أو أي وجميع المعلومات الشخصية و / أو المعلومات المالية
              مخزنة فيه ، (4) أي انقطاع أو توقف للإرسال إلى أو من الموقع أو عروض التجارة
              الإلكترونية ، (5) أي أخطاء أو فيروسات أو خيول طروادة ، أو ما شابه ذلك يمكن
              نقله إلى أو من خلاله و / أو (6) أي أخطاء أو سهو في أي محتوى أو مواد أو عن أي
              خسارة أو ضرر من أي نوع يحدث نتيجة استخدام أي محتوى منشور أو تم نقله أو متاح
              بطريقة أخرى عبر الموقع. نحن لا نضمن أو نصادق أو نضمن أو نتحمل المسؤولية عن
              أي منتج أو خدمة يتم الإعلان عنها أو تقديمها من قبل طرف ثالث من خلال الموقع
              أو أي موقع ويب مرتبط أو أي موقع ويب أو تطبيق جوال معلن عنه أو غير معلن عنه
              أو في أي موقع إلكتروني معلن عنه أو يقدمه. كن طرفًا أو مسؤولاً بأي شكل من
              الأشكال عن مراقبة أي معاملة بينك وبين أي طرف ثالث من مقدمي المنتجات أو
              الخدمات. كما هو الحال مع شراء منتج أو خدمة من خلال أي وسيط أو في أي بيئة ،
              يجب عليك استخدام أفضل حكم لك وتوخي الحذر حيثما كان ذلك مناسبًا.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.6nvd0s9yekso">
            <span class="c1">حدود المسؤولية</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >لن نتحمل نحن أو مديرينا أو موظفونا أو وكلائنا بأي حال من الأحوال المسؤولية
              تجاهك أو تجاه أي طرف ثالث عن أي أضرار مباشرة أو غير مباشرة أو تبعية أو
              نموذجية أو عرضية أو خاصة أو عقابية ، بما في ذلك خسارة الأرباح أو الخسائر. أو
              الأضرار الأخرى الناشئة عن استخدامك للموقع أو عروض التجارة الإلكترونية ، حتى
              لو تم إعلامنا بإمكانية حدوث مثل هذه الأضرار. بصرف النظر عن أي شيء مخالف لما
              ورد في هذه الوثيقة ، فإن مسؤوليتنا تجاهك تجاه أي سبب مهما كان وبغض النظر عن
              شكل الإجراء ، ستقتصر في جميع الأوقات على المبلغ المدفوع ، إن وجد ، بواسطتك
              لنا. لا تسمح بعض قوانين الولايات الأمريكية والقوانين الدولية بفرض قيود على
              الضمانات الضمنية أو استثناء أو تقييد بعض الأضرار. إذا كانت هذه القوانين
              تنطبق عليك ، فقد لا تنطبق عليك بعض أو كل إخلاء المسؤولية أو القيود المذكورة
              أعلاه ، وقد يكون لديك حقوق إضافية.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.25ntati0uiqf">
            <span class="c1">التعويض</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >أنت توافق على الدفاع عنا وتعويضنا وإعفائنا من الضرر ، بما في ذلك الشركات
              التابعة لنا والشركات التابعة لنا وجميع مسؤولينا ووكلائنا وشركائنا وموظفينا ،
              من وضد أي خسارة أو ضرر أو مسؤولية أو مطالبة أو طلب ، بما في ذلك المحامون
              المعقولون الرسوم والنفقات ، التي يدفعها أي طرف ثالث بسبب أو ناشئة عن: (1)
              مساهماتك ؛ (2) استخدام عروض التجارة الإلكترونية ؛ (3) خرق شروط الاستخدام هذه
              ؛ (4) أي خرق لإقراراتك وضماناتك المنصوص عليها في شروط الاستخدام هذه ؛ (5)
              انتهاكك لحقوق طرف ثالث ، بما في ذلك على سبيل المثال لا الحصر حقوق الملكية
              الفكرية ؛ أو (6) أي عمل ضار صريح تجاه أي مستخدم آخر للموقع أو عروض التجارة
              الإلكترونية التي اتصلت بها عبر الموقع. على الرغم مما سبق ذكره ، فإننا نحتفظ
              بالحق ، على نفقتك الخاصة ، في تولي الدفاع الحصري والتحكم في أي مسألة يُطلب
              منك تعويضنا عنها ، وتوافق على التعاون ، على نفقتك الخاصة ، مع دفاعنا عن هذه
              المطالبات. سنبذل جهودًا معقولة لإعلامك بأي مطالبة أو إجراء أو إجراء يخضع
              لهذا التعويض بمجرد علمك به.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.rca6c6vkohfe">
            <span class="c1">بيانات المستخدم</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >سنحتفظ ببعض البيانات التي ترسلها إلى الموقع بغرض إدارة أداء عروض التجارة
              الإلكترونية ، فضلاً عن البيانات المتعلقة باستخدامك لعروض التجارة
              الإلكترونية. على الرغم من أننا نقوم بإجراء نسخ احتياطية روتينية منتظمة
              للبيانات ، فأنت وحدك المسؤول عن جميع البيانات التي ترسلها أو التي تتعلق بأي
              نشاط قمت به باستخدام عروض التجارة الإلكترونية. أنت توافق على أننا لن نتحمل
              أي مسؤولية تجاهك عن أي خسارة أو تلف في أي من هذه البيانات ، وأنت تتنازل
              بموجب هذا عن أي حق في اتخاذ إجراء ضدنا ناشئ عن أي فقدان أو تلف لهذه
              البيانات.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.qrqblnesmtaw">
            <span class="c1">الاتصالات والمعاملات والتوقيعات الإلكترونية</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >تشكل زيارة الموقع وإرسال رسائل البريد الإلكتروني إلينا واستكمال النماذج عبر
              الإنترنت اتصالات إلكترونية. أنت توافق على تلقي الاتصالات الإلكترونية ،
              وتوافق على أن جميع الاتفاقيات والإشعارات والإفصاحات وغيرها من الاتصالات التي
              نقدمها لك إلكترونيًا ، عبر البريد الإلكتروني وعلى الموقع ، تفي بأي شرط
              قانوني بأن يكون هذا الاتصال كتابيًا. أنت توافق بموجب هذا على استخدام
              التوقيعات الإلكترونية والعقود والأوامر والسجلات الأخرى ، وعلى التسليم
              الإلكتروني للإشعارات والسياسات وسجلات المعاملات التي تم البدء فيها أو
              إكمالها بواسطتنا أو عبر الموقع. أنت تتنازل بموجب هذا عن أي حقوق أو متطلبات
              بموجب أي قوانين أو لوائح أو قواعد أو مراسيم أو قوانين أخرى في أي ولاية
              قضائية تتطلب توقيعًا أصليًا أو تسليم أو الاحتفاظ بسجلات غير إلكترونية ، أو
              عن المدفوعات أو منح ائتمانات بأي وسيلة أخرى من الوسائل الإلكترونية.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.qq72d3j44slb"><span class="c1">متنوع</span></h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >تشكل شروط الاستخدام هذه وأي سياسات أو قواعد تشغيل ننشرها على الموقع أو فيما
              يتعلق بعروض التجارة الإلكترونية الاتفاقية الكاملة والتفاهم بينك وبيننا. إن
              إخفاقنا في ممارسة أو إنفاذ أي حق أو حكم من شروط الاستخدام هذه لا يعتبر
              بمثابة تنازل عن هذا الحق أو الحكم. تعمل شروط الاستخدام هذه إلى أقصى حد يسمح
              به القانون. يجوز لنا التنازل عن أي من حقوقنا والتزاماتنا أو جميعها للآخرين
              في أي وقت. لن نكون مسؤولين أو مسؤولين عن أي خسارة أو ضرر أو تأخير أو فشل في
              التصرف بسبب أي سبب خارج عن سيطرتنا المعقولة. إذا تم تحديد أي بند أو جزء من
              شرط من شروط الاستخدام هذه على أنه غير قانوني أو باطل أو غير قابل للتنفيذ ،
              فإن هذا الحكم أو جزء من الحكم يعتبر قابلاً للفصل عن شروط الاستخدام هذه ولا
              يؤثر على صلاحية وإمكانية إنفاذ أي بند متبقي الأحكام. لا توجد علاقة مشروع
              مشترك أو شراكة أو توظيف أو وكالة بينك وبيننا نتيجة لشروط الاستخدام هذه أو
              استخدام عروض التجارة الإلكترونية. أنت توافق على أن شروط الاستخدام هذه لن يتم
              تفسيرها ضدنا بحكم صياغتها. أنت تتنازل بموجبه عن أي وجميع الدفاعات التي قد
              تكون لديك بناءً على الشكل الإلكتروني لشروط الاستخدام هذه وعدم توقيع الأطراف
              بهذه الاتفاقية لتنفيذ شروط الاستخدام هذه.</span
            >
          </p>
          <h2 class="c6" dir="rtl" id="h.5v3dtq16kuuv">
            <span class="c1">اتصل بنا</span>
          </h2>
          <p class="c5" dir="rtl">
            <span class="c0"
              >لحل شكوى تتعلق بالموقع أو عروض التجارة الإلكترونية أو لتلقي مزيد من
              المعلومات بشأن استخدام الموقع أو عروض التجارة الإلكترونية ، يرجى الاتصال بنا
              على: support&#64;popsy.app</span
            >
          </p>
          <p class="c5" dir="rtl">
            <span class="c0">اقرأ الأسئلة الشائعة الكاملة على:</span>
          </p>
          <p class="c5" dir="rtl"><span class="c0">إنجليزي</span></p>
          <p class="c5" dir="rtl">
            <span class="c15"
              ><a
                class="c18"
                href="https://www.google.com/url?q=https://www.popsy.app/faq?lang=en&amp;sa=D&amp;source=editors&amp;ust=1680258966947990&amp;usg=AOvVaw2xNgaHaVWncwubZ0A123lJ"
                >https://us.popsy.app/faq</a
              ></span
            >
          </p>
          <p class="c5" dir="rtl"><span class="c0">عربي</span></p>
          <p class="c5" dir="rtl">
            <span class="c15"
              ><a
                class="c11"
                href="https://www.google.com/url?q=https://ae.popsy.app/faq&amp;sa=D&amp;source=editors&amp;ust=1680259268390441&amp;usg=AOvVaw1VDUmyOV_VCHLwffcNpps0"
                >https://ae.popsy.app/faq</a
              ></span
            >
          </p>
          <p class="c5 c19" dir="rtl"><span class="c0"></span></p>
          <p class="c5 c19" dir="rtl"><span class="c0"></span></p>
        </section>
      </article>
      <span
        class="fixed-space-64"
        aria-hidden="true"
        *ngIf="(lessThan$ | async)?.mobileL !== true"></span>
      <ng-container *ngIf="!(inFullScreenMode$ | async)">
        <app-footer
          class="footer"
          [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
      </ng-container>
    </div>
  </div>
</main>
